import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";
import Collapse from "react-bootstrap/Collapse";
import { callApi } from "../../utils/api";
import {
  formatChecklistDateForDisplay,
  formatChecklistDatesInRuntime,
  checklistValueForMappedSave,
  isChecklistDateField,
  maskChecklistDateInput,
  checklistDateInputValue,
  CHECKLIST_DATE_DISPLAY_FORMAT,
} from "../../utils/checklistDateFormat";
import {
  applyScrutinyTagPrefill,
  applyScrutinyFollowUpPrefill,
  applyDeedDocumentVerificationPrefill,
  applySurveyVerificationPrefill,
  collectDeedDocumentEntriesInSaveOrder,
  deedDocumentEntryVisible,
  DeedDocumentEntryInOrder,
  resolveScrutinyFieldSaveTag,
  sortDeedGatesBySaveOrder,
  sortRepeatableRowIndices,
  sortRepeatableRowsBySaveOrder,
  titleDeedRowForDocument,
  AddressPropertyLineMeta,
  buildAddressPropertyDetailUpdates,
  DeedMasterRowLite,
  fetchDeedMasterList,
  fetchScrutinyChecklistForFile,
  hasPersistedDynamicSnapshot,
  isAddressOfPropertyMappedField,
  MISSING_LOD_REPEATABLE_SUFFIX,
  PRE_DISBURSEMENT_REPEATABLE_SUFFIX,
  POST_DISBURSEMENT_REPEATABLE_SUFFIX,
  PRE_DISBURSEMENT_META_ID_KEY,
  POST_DISBURSEMENT_META_ID_KEY,
  PRE_DISBURSEMENT_TAG_TO_ROW_KEY,
  POST_DISBURSEMENT_TAG_TO_ROW_KEY,
  parseAddressPropertyLineMeta,
  parseAddressOfPropertyStored,
  REPEATABLE_DOC_BASE_ID_META_KEY,
  REPEATABLE_DOC_NO_META_KEY,
  REPEATABLE_DS_ID_META_KEY,
  normalizeDynamicTagId,
  serializeAddressOfPropertyStored,
  resolveScrutinyFieldTag,
  isOriginalPresentScrutinySaveTag,
  isOriginalPresentYesNoValue,
  isScrutinyScalarDataColumnSaveTag,
  reconcileMissingSheetsInFieldRow,
  normalizeMissingSheetsScalar,
  isMissingSheetsField,
} from "../../utils/dynamicChecklistScrutinyPrefill";
import {
  ChecklistFieldDef,
  ChecklistSectionDef,
  ChecklistRepeatableGroupDef,
  ChecklistFieldType,
  DropdownOptionFollowUpDef,
  FRONT_OFFICE_CATALOG,
  FRONT_OFFICE_TITLE_DEED_SOURCE_IDS,
  SearchableSelect,
  DVC_CSS,
  sortSections,
  normalizeMasterFromApi,
  emptyValuesFromMaster,
  emptyRepeatableValuesFromMaster,
  layoutToColMd,
  labelForParentFollowBranch,
  triggerFollowBranchKey,
  triggerFollowBranchKeyForValue,
  branchKeyForFollowUpAnswer,
  reconcileAllFollowUpClears,
  reconcileRepeatableRowFollowUpClears,
  applyConditionalFollowUpClearForParentValue,
  repeatableRowFollowUpStorageKey,
  seedRepeatableRowFollowUpKeys,
  preserveFollowUpDefaultsInChecklist,
} from "../DynamicChecklistManagement/DynamicChecklistManagement";
import {
  enrichChecklistValuesForPersist,
  enrichRepeatableValuesForPersist,
  rebuildChecklistValuesFromPersist,
  restoreNatureScopedFieldsFromPersist,
  restoreRepeatableHierarchyFieldsFromPersist,
  collectAllChecklistFieldsFromMaster,
} from "../../utils/dynamicChecklistPersistRestore";
import { normalizeMappedDropdownValue, isChecklistTruthyScalar, isChecklistFalsyScalar } from "../../utils/dynamicChecklistDropdownValue";
import {
  repeatableEntriesKey,
  isChecklistAnswerFilled,
  collectVisibleFollowUpValidationMissing,
  fieldIdsInDeedGroups,
  labelTagHintForField,
  sectionFlowMode,
  sectionGateFields,
  deedLinkedGroups,
  bankLinkedGroups,
  bankGroupsVisibleForFile,
  bankProductSectionFieldCount,
  resolveFileBankProductId,
  normalizeDeedIdForSelect,
  fieldTypeAllowsVerifyCheckbox,
  PRE_DISBURSEMENT_DYNAMIC_TAG_IDS,
  POST_DISBURSEMENT_DYNAMIC_TAG_IDS,
  ADDON_SCALAR_DYNAMIC_TAG_IDS,
  fieldTypeSupportsOptionFollowUps,
  fieldHasConfiguredFollowUps,
} from "../DynamicChecklistManagement/DynamicChecklistManagement";
import {
  surveyGroupsVisibleForFile,
  surveyLinkedGroups,
  matchNaturePropertyKey,
  naturePropertyLabel,
  resolveSurveyNaturePropertyKeys,
  resolveVisibleSurveyNatureGroups,
  surveyConfiguredNatureGroups,
  surveyConfiguredNatureCards,
  surveyNatureFieldScopeKey,
  surveyNatureSectionFieldCountForVisibleGroups,
} from "../../utils/dynamicChecklistSurveyNature";
import {
  applyEcVerificationPrefill,
  EC_HIERARCHY_META,
  ecBlockGroup,
  ecBlockDisplayLabel,
  ecBlocksFromScrutiny,
  ecEntryGroup,
  ecSectionFieldCount,
  relatedEntryRowsForBlock,
} from "../../utils/dynamicChecklistEcVerification";
import {
  GeneralDetailsDocumentHierarchy,
  GeneralDetailsScheduleRow,
  MEAS_DIR_CUSTOM_LABEL_BY_FIELD_PREFIX,
  MEAS_DIR_CUSTOM_LABELS_KEY,
  MEAS_DIR_CUSTOM_LABELS_JSON_KEY,
  MEAS_DIR_CUSTOM_VALUES_KEY,
  MEAS_DIR_CUSTOM_VALUES_JSON_KEY,
  SURVEY_HIERARCHY_META,
  resolveSurveyDocumentFdId,
  resolveSurveyDocumentFdWithSchedules,
  listSurveyDocumentFdIdsWithSchedules,
  scheduleDisplayNumber,
  resolveSurveyDocumentMeta,
  surveyHierarchyGroupForLevel,
  surveyHierarchyGroupHasChecklistFields,
  surveyHierarchyLinkedGroups,
  surveySectionUsesHierarchy,
  SurveyHierarchyLevel,
  resolveSurveyTypeFromHierarchyRow,
  isSurveyFieldVisibleForSurveyType,
  mergeSurveyTypeVisibilityRow,
  resolveGdSurveyVisibilityRow,
  SurveyTypeFieldSource,
} from "../../utils/dynamicChecklistSurveyHierarchy";
import { buildEcVerificationUpdates } from "../../utils/dynamicChecklistEcVerificationSave";
import { buildSurveyVerificationUpdates } from "../../utils/dynamicChecklistSurveyHierarchySave";
import {
  collectLegalHeirsFromRow,
  getLegalHeirInputCount,
  isLegalHeirsMappedField,
  legalHeirValueKey,
} from "../../utils/dynamicChecklistLegalHeirs";
import {
  collectDocumentScheduleSetsFromRow,
  documentScheduleFieldsInGroup,
  documentScheduleSetValueKey,
  getDocumentScheduleSetCount,
  isDocumentScheduleMappedField,
} from "../../utils/dynamicChecklistDocumentSchedule";

const MISSING_LOD_TAGS = new Set([
  "fileNo",
  "fileName",
  "totalSheets",
  "availableSheets",
  "missingSheets",
]);

function surveyTypeVisibilityRowFromDocument(
  gdByDoc: Record<string, GeneralDetailsDocumentHierarchy>,
  fdId: string | undefined,
  scheduleId?: string,
  surId?: string
): Record<string, string> {
  return resolveGdSurveyVisibilityRow(gdByDoc, fdId, scheduleId, surId ? { sur_id: surId } : null);
}

function mergedGeneralDetailsByDocument(
  state: Record<string, GeneralDetailsDocumentHierarchy>,
  scrutinyApiCache: any
): Record<string, GeneralDetailsDocumentHierarchy> {
  return {
    ...(scrutinyApiCache?.generalDetailsByDocument &&
    typeof scrutinyApiCache.generalDetailsByDocument === "object"
      ? (scrutinyApiCache.generalDetailsByDocument as Record<
          string,
          GeneralDetailsDocumentHierarchy
        >)
      : {}),
    ...state,
  };
}

function mappedFieldsForTagSet(
  section: ChecklistSectionDef,
  tagSet: Set<string>
): ChecklistFieldDef[] {
  return section.fields.filter((f) => {
    const tag = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
    return !!tag && tagSet.has(tag);
  });
}

function buildDisbursementDocumentUpdates(
  section: ChecklistSectionDef,
  mappedFields: ChecklistFieldDef[],
  repeatableValues: Record<string, Record<string, string>[]>,
  groupSuffix: string,
  metaIdKey: string,
  idField: "preDisbursementId" | "postDisbursementId",
  tagToRowKey: Record<string, string>
): AddonDisbursementDocumentUpdate[] {
  if (!mappedFields.length) return [];
  const key = repeatableEntriesKey(section.id, groupSuffix);
  const rows = repeatableValues[key] || [];
  const out: AddonDisbursementDocumentUpdate[] = [];
  rows.forEach((row) => {
    const doc: AddonDisbursementDocumentUpdate = {};
    const rawId = String(row[metaIdKey] ?? "").trim();
    if (rawId) {
      const parsedId = Number(rawId);
      if (Number.isFinite(parsedId) && parsedId > 0) {
        doc[idField] = parsedId;
      }
    }
    mappedFields.forEach((f) => {
      if (f.disabled) return;
      const tag = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
      const rowKey = tag ? tagToRowKey[tag] : undefined;
      if (!rowKey) return;
      (doc as Record<string, string>)[rowKey] = checklistValueForMappedSave(
        f,
        String(row[f.id] ?? "")
      );
    });
    const hasValues =
      String(doc.date ?? "").trim() !== "" ||
      String(doc.document_number ?? "").trim() !== "" ||
      String(doc.particular_deed ?? "").trim() !== "" ||
      String(doc.nature_deed ?? "").trim() !== "" ||
      doc[idField] != null;
    if (hasValues) out.push(doc);
  });
  return out;
}

function buildStandaloneDisbursementDocumentUpdate(
  mappedFields: ChecklistFieldDef[],
  checklistValues: Record<string, string>,
  tagToRowKey: Record<string, string>
): AddonDisbursementDocumentUpdate | null {
  if (!mappedFields.length) return null;
  const doc: AddonDisbursementDocumentUpdate = {};
  mappedFields.forEach((f) => {
    if (f.disabled) return;
    const tag = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
    const rowKey = tag ? tagToRowKey[tag] : undefined;
    if (!rowKey) return;
    (doc as Record<string, string>)[rowKey] = checklistValueForMappedSave(
      f,
      String(checklistValues[f.id] ?? "")
    );
  });
  const hasValues =
    String(doc.date ?? "").trim() !== "" ||
    String(doc.document_number ?? "").trim() !== "" ||
    String(doc.particular_deed ?? "").trim() !== "" ||
    String(doc.nature_deed ?? "").trim() !== "";
  return hasValues ? doc : null;
}

/** Runtime accordion: explicit open state; first section open by default. */
function runtimeInitSectionOpen(sections: ChecklistSectionDef[]): Record<string, boolean> {
  const sorted = sortSections(sections);
  const open: Record<string, boolean> = {};
  let defaultAssigned = false;
  sorted.forEach((section) => {
    if (section.defaultExpanded === true) {
      open[section.id] = true;
      defaultAssigned = true;
      return;
    }
    if (section.defaultExpanded === false) {
      open[section.id] = false;
      return;
    }
    if (!defaultAssigned) {
      open[section.id] = true;
      defaultAssigned = true;
      return;
    }
    open[section.id] = false;
  });
  return open;
}

/**
 * Runtime answer payload produced by this component and persisted by the
 * parent (work-file Verification / Process Checklist) inside
 * `TBL_VERIFICATIONCHECKLIST.Current_json` under the `dynamic` key.
 */
export interface DynamicChecklistRuntimeValue {
  checklistValues: Record<string, string>;
  repeatableValues: Record<string, Record<string, string>[]>;
  fieldVerified: Record<string, string>;
}

export interface DynamicChecklistRuntimeApi {
  validate: () => string[];
  getValue: () => DynamicChecklistRuntimeValue;
  reload: () => void;
  syncMappedValues: () => Promise<void>;
}

type MappedPropertyDetailUpdates = {
  addressLines: { fodFk: number; generalDetailId?: number; address: string }[];
};

type AddonDisbursementDocumentUpdate = {
  preDisbursementId?: number;
  postDisbursementId?: number;
  date?: string;
  document_number?: string;
  particular_deed?: string;
  nature_deed?: string;
};

type MappedValueUpdates = {
  frontOfficeUpdates: { field: string; value: string }[];
  scrutinyUpdates: Array<{
    deedMasterId: number;
    rowIndex: number;
    /** Scrutiny document row (`tbl_doc_scurty.id`) from repeatable row meta. */
    dsId?: number;
    mappedField: string;
    value: string;
  }>;
  propertyDetailUpdates: MappedPropertyDetailUpdates | null;
  addonFeatureUpdates: { field: string; value: string }[];
  preDisbursementDocuments: AddonDisbursementDocumentUpdate[];
  postDisbursementDocuments: AddonDisbursementDocumentUpdate[];
  ecVerificationUpdates: ReturnType<typeof buildEcVerificationUpdates>;
  surveyVerificationUpdates: ReturnType<typeof buildSurveyVerificationUpdates>;
};

function hierarchyRowsForDocument(
  sectionId: string,
  groupId: string,
  fdId: string,
  repeatableValues: Record<string, Record<string, string>[]>,
  parentMeta?: Record<string, string>
): { row: Record<string, string>; rowIndex: number }[] {
  const key = repeatableEntriesKey(sectionId, groupId);
  const all = repeatableValues[key] || [];
  const fd = String(fdId ?? "").trim();
  const out: { row: Record<string, string>; rowIndex: number }[] = [];
  const seenMeasurementIds = new Set<string>();
  const parentMeasId = String(parentMeta?.[SURVEY_HIERARCHY_META.MEASUREMENT_ID] ?? "").trim();
  all.forEach((row, rowIndex) => {
    if (fd && String(row[SURVEY_HIERARCHY_META.FD_ID] ?? "").trim() !== fd) return;
    if (parentMeta) {
      for (const mk of Object.keys(parentMeta)) {
        const expected = String(parentMeta[mk] ?? "").trim();
        if (expected && String(row[mk] ?? "").trim() !== expected) return;
      }
    }
    if (parentMeasId) {
      const dedupeKey = [
        row[SURVEY_HIERARCHY_META.BOUNDARY_ID] ?? "",
        row[SURVEY_HIERARCHY_META.MEASUREMENT_ID] ?? "",
      ].join("|");
      if (seenMeasurementIds.has(dedupeKey)) return;
      seenMeasurementIds.add(dedupeKey);
    }
    out.push({ row, rowIndex });
  });
  return out;
}

export interface DynamicChecklistRuntimeProps {
  fileId: string | number;
  /** Saved runtime answers loaded from `TBL_VERIFICATIONCHECKLIST.Current_json` (if any). */
  initialValue?: Partial<DynamicChecklistRuntimeValue> | null;
  /** True when `Current_json` already contains a `dynamic` snapshot (even if sparse). */
  persistedSnapshot?: boolean;
  onChange?: (val: DynamicChecklistRuntimeValue) => void;
  onLoaded?: (val: DynamicChecklistRuntimeValue, master: ChecklistSectionDef[]) => void;
  /** Expose an imperative handle (validate / getValue / reload) to the parent. */
  apiRef?: (api: DynamicChecklistRuntimeApi) => void;
  /** Optional title shown above the section list. Defaults to "Dynamic checklist". */
  title?: string;
  /** Optional intro text under the title. */
  intro?: React.ReactNode;
  /** When set, survey verification hierarchy is scoped to this document (`base_id` / `fd_id`). */
  activeDocumentFdId?: string | number | null;
  /** Optional callback: preview source document for a deed entry. */
  onPreviewEntryDocument?: (payload: { docNo?: string; baseId?: string }) => void;
}

interface RuntimeState {
  master: ChecklistSectionDef[];
  checklistValues: Record<string, string>;
  repeatableValues: Record<string, Record<string, string>[]>;
  fieldVerified: Record<string, string>;
  sectionUiOpen: Record<string, boolean>;
  masterLoading: boolean;
  loadError: string | null;
  validationMessages: string[];
  /** Front-office row keyed by catalog id (e.g. `borrower_name`, `app_id`). */
  frontOfficePrefill: Record<string, string>;
  /** General Detail address row per scrutiny document (line order matches address inputs). */
  addressPropertyLines: AddressPropertyLineMeta[];
  /** Full General Detail tree keyed by document fd_id (from scrutiny API). */
  generalDetailsByDocument: Record<string, GeneralDetailsDocumentHierarchy>;
  /** Property details row from scrutiny API (`propertyDetails`). */
  propertyDetailsPrefill: Record<string, string>;
}

/**
 * Merge an external `initialValue` snapshot into the freshly-seeded runtime
 * state, preserving the seeded defaults for any keys that the snapshot does
 * not provide. We deliberately do not blindly overwrite — the seeded values
 * include checkbox `"false"` defaults that should not be lost if the snapshot
 * omits them. Yes/no fields default to empty until the user selects Yes or No.
 */
function mergeInitial(
  base: DynamicChecklistRuntimeValue,
  initial?: Partial<DynamicChecklistRuntimeValue> | null
): DynamicChecklistRuntimeValue {
  if (!initial) return base;
  const next: DynamicChecklistRuntimeValue = {
    checklistValues: { ...base.checklistValues },
    repeatableValues: { ...base.repeatableValues },
    fieldVerified: { ...base.fieldVerified },
  };
  if (initial.checklistValues && typeof initial.checklistValues === "object") {
    Object.keys(initial.checklistValues).forEach((k) => {
      const v = initial.checklistValues![k];
      if (v !== undefined && v !== null) next.checklistValues[k] = String(v);
    });
  }
  if (initial.repeatableValues && typeof initial.repeatableValues === "object") {
    Object.keys(initial.repeatableValues).forEach((k) => {
      const rows = initial.repeatableValues![k];
      if (!Array.isArray(rows)) return;
      const seededRows = next.repeatableValues[k] || [];
      const mergedRows: Record<string, string>[] = rows.map((savedRow, idx) => {
        const baseRow = seededRows[idx] ? { ...seededRows[idx] } : {};
        if (savedRow && typeof savedRow === "object") {
          Object.keys(savedRow).forEach((kk) => {
            const vv = (savedRow as Record<string, unknown>)[kk];
            if (vv != null) baseRow[kk] = String(vv);
          });
        }
        return baseRow;
      });
      if (seededRows.length > mergedRows.length) {
        mergedRows.push(...seededRows.slice(mergedRows.length).map((r) => ({ ...r })));
      }
      next.repeatableValues[k] = mergedRows;
    });
  }
  if (initial.fieldVerified && typeof initial.fieldVerified === "object") {
    Object.keys(initial.fieldVerified).forEach((k) => {
      const v = initial.fieldVerified![k];
      if (v !== undefined && v !== null) next.fieldVerified[k] = String(v);
    });
  }
  return next;
}

/** Context for rendering / validating follow-ups (standalone or inside a repeatable row). */
interface FollowUpRuntimeContext {
  checklist: Record<string, string>;
  storageKey: (valueKey: string) => string;
  onFollowUpChange: (storageKey: string, val: string) => void;
  keyPrefix: string;
}

function findFieldInMaster(
  master: ChecklistSectionDef[],
  sectionId: string,
  groupId: string | null,
  fieldId: string
): ChecklistFieldDef | undefined {
  const section = master.find((s) => s.id === sectionId);
  if (!section) return undefined;
  if (groupId) {
    const group = (section.repeatableGroups || []).find((g) => g.id === groupId);
    return group?.fields.find((f) => f.id === fieldId);
  }
  return section.fields.find((f) => f.id === fieldId);
}

function workFileFieldShowsVerify(field: ChecklistFieldDef): boolean {
  return fieldTypeAllowsVerifyCheckbox(field.type) && !!field.showVerifyCheckbox;
}

/** Stable key for repeatable-row verify state (one checkbox per row × field). */
function repeatableRowVerifyKey(
  sectionId: string,
  groupId: string,
  rowIndex: number,
  fieldId: string
): string {
  return `${repeatableEntriesKey(sectionId, groupId)}::${rowIndex}::${fieldId}`;
}

function initFollowUpVerifiedKeys(
  nodes: DropdownOptionFollowUpDef[] | undefined,
  out: Record<string, string>
): void {
  if (!nodes) return;
  nodes.forEach((n) => {
    if (n.questionType !== "yes_no") out[n.valueKey] = out[n.valueKey] ?? "false";
    initFollowUpVerifiedKeys(n.nestedFollowUps, out);
  });
}

/**
 * Seeds `fieldVerified` for all master fields across checklist, document-type,
 * and bank-product flows (plus follow-ups and repeatable rows).
 */
function initWorkFileFieldVerified(
  sections: ChecklistSectionDef[],
  repeatableValues: Record<string, Record<string, string>[]>
): Record<string, string> {
  const out: Record<string, string> = {};
  sections.forEach((s) => {
    s.fields.forEach((f) => {
      if (workFileFieldShowsVerify(f)) out[f.id] = "false";
      if (f.optionFollowUps?.length) initFollowUpVerifiedKeys(f.optionFollowUps, out);
    });
    (s.repeatableGroups || []).forEach((g) => {
      if (g.bankProductId != null || g.naturePropertyKey != null) {
        g.fields.forEach((f) => {
          if (workFileFieldShowsVerify(f)) out[f.id] = "false";
          if (f.optionFollowUps?.length) initFollowUpVerifiedKeys(f.optionFollowUps, out);
        });
        return;
      }
      const rk = repeatableEntriesKey(s.id, g.id);
      const rows = repeatableValues[rk] || [];
      rows.forEach((_, rowIdx) => {
        g.fields.forEach((f) => {
          if (!workFileFieldShowsVerify(f)) return;
          out[repeatableRowVerifyKey(s.id, g.id, rowIdx, f.id)] = "false";
          if (f.optionFollowUps?.length) initFollowUpVerifiedKeys(f.optionFollowUps, out);
        });
      });
    });
  });
  return out;
}

function mergeFieldVerifiedWithMaster(
  sections: ChecklistSectionDef[],
  repeatableValues: Record<string, Record<string, string>[]>,
  saved: Record<string, string>
): Record<string, string> {
  const defaults = initWorkFileFieldVerified(sections, repeatableValues);
  return { ...defaults, ...saved };
}

/**
 * For each field whose `dynamicValueSource === "front_office"` and that has a
 * `scrutinyLinkedDeedId` catalog id, copy the corresponding value from the
 * loaded front-office row into `checklistValues`. Only applied for text/date/
 * remarks fields where a free-form value makes sense — typed controls such as
 * yes_no / checkbox / dropdown keep their snapshot value.
 */
function applyFrontOfficePrefill(
  sections: ChecklistSectionDef[],
  values: Record<string, string>,
  frontOfficeRow: Record<string, string>
): Record<string, string> {
  if (!frontOfficeRow || !Object.keys(frontOfficeRow).length) return values;
  const out = { ...values };
  const prefillField = (f: ChecklistFieldDef) => {
    if (f.dynamicValueSource !== "front_office") return;
    const id = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
    if (!id) return;
    if (!FRONT_OFFICE_CATALOG.some((c) => c.id === id)) return;
    if (f.type !== "text" && f.type !== "date" && f.type !== "remarks") return;
    const existing = out[f.id];
    if (existing && String(existing).trim()) return;
    const src = frontOfficeRow[id];
    if (src == null) return;
    const next = String(src);
    if (!next.trim()) return;
    out[f.id] = next;
  };
  sections.forEach((s) => {
    s.fields.forEach(prefillField);
    (s.repeatableGroups || []).forEach((g) => {
      if (g.bankProductId == null && g.naturePropertyKey == null) return;
      g.fields.forEach(prefillField);
    });
  });
  return out;
}

/**
 * Drop-in runtime renderer for the dynamic checklist master. Used by the
 * work-file Verification and Process Checklist pages — they own the surrounding
 * scaffolding (PDF viewer, EOD, hold, queries, Save button, remarks) and just
 * mount this component where the static `DataModel`-driven checklist used to
 * live.
 */
export class DynamicChecklistRuntime extends Component<
  DynamicChecklistRuntimeProps,
  RuntimeState
> {
  private scrutinyApiCache: any = null;
  private deedMasterListCache: DeedMasterRowLite[] = [];

  state: RuntimeState = {
    master: [],
    checklistValues: {},
    repeatableValues: {},
    fieldVerified: {},
    sectionUiOpen: {},
    masterLoading: true,
    loadError: null,
    validationMessages: [],
    frontOfficePrefill: {},
    addressPropertyLines: [],
    generalDetailsByDocument: {},
    propertyDetailsPrefill: {},
  };

  componentDidMount() {
    this.publishApi();
    this.loadAll();
  }

  componentDidUpdate(prev: DynamicChecklistRuntimeProps) {
    if (prev.fileId !== this.props.fileId) {
      this.loadAll();
    } else if (prev.initialValue !== this.props.initialValue) {
      this.applyInitialValue();
    } else if (
      String(prev.activeDocumentFdId ?? "") !== String(this.props.activeDocumentFdId ?? "") &&
      this.scrutinyApiCache &&
      this.state.master.length
    ) {
      this.applySurveyDocumentPrefill(true);
    }
  }

  applySurveyDocumentPrefill = (forceHierarchyFields = false) => {
    if (!this.scrutinyApiCache) return;
    const checklistValues = { ...this.state.checklistValues };
    const repeatableValues = Object.keys(this.state.repeatableValues).reduce<
      Record<string, Record<string, string>[]>
    >((acc, k) => {
      acc[k] = (this.state.repeatableValues[k] || []).map((r) => ({ ...r }));
      return acc;
    }, {});
    applySurveyVerificationPrefill(
      this.state.master,
      checklistValues,
      repeatableValues,
      this.scrutinyApiCache,
      {
        activeDocumentFdId: this.props.activeDocumentFdId ?? null,
        propertyDetails: this.state.propertyDetailsPrefill,
        generalDetailsByDocument: this.state.generalDetailsByDocument,
        forceHierarchyFields,
      }
    );
    this.setState({ checklistValues, repeatableValues }, () => this.emitChange());
  };

  applyDeedDocumentPrefill = (reconcileGates = false) => {
    if (!this.scrutinyApiCache) return;
    const checklistValues = { ...this.state.checklistValues };
    const repeatableValues = Object.keys(this.state.repeatableValues).reduce<
      Record<string, Record<string, string>[]>
    >((acc, k) => {
      acc[k] = (this.state.repeatableValues[k] || []).map((r) => ({ ...r }));
      return acc;
    }, {});
    applyDeedDocumentVerificationPrefill(
      this.state.master,
      checklistValues,
      repeatableValues,
      this.scrutinyApiCache,
      {
        deedMasterList: this.deedMasterListCache,
        reconcileGates,
        // When reconciling gates from live documents, also refresh mapped scalars
        // (extent, favour, …) so ScrutinyForm edits show in the checklist.
        forceMappedFields: reconcileGates === true,
      }
    );
    formatChecklistDatesInRuntime(this.state.master, {
      checklistValues,
      repeatableValues,
      fieldVerified: this.state.fieldVerified,
    });
    this.setState({ checklistValues, repeatableValues }, () => this.emitChange());
  };

  /** Survey + deed document prefill in one state update (persisted snapshot reload). */
  applyPersistedDocumentPrefill = () => {
    if (!this.scrutinyApiCache) return;
    const checklistValues = { ...this.state.checklistValues };
    const repeatableValues = Object.keys(this.state.repeatableValues).reduce<
      Record<string, Record<string, string>[]>
    >((acc, k) => {
      acc[k] = (this.state.repeatableValues[k] || []).map((r) => ({ ...r }));
      return acc;
    }, {});
    applySurveyVerificationPrefill(
      this.state.master,
      checklistValues,
      repeatableValues,
      this.scrutinyApiCache,
      {
        activeDocumentFdId: this.props.activeDocumentFdId ?? null,
        propertyDetails: this.state.propertyDetailsPrefill,
        generalDetailsByDocument: this.state.generalDetailsByDocument,
        // Hierarchy fields mirror General Detail. Always re-sync from GD on load
        // so document edits (schedule/survey/boundary/measurement) show in checklist.
        // Checklist-only answers remain from the saved snapshot.
        forceHierarchyFields: true,
      }
    );
    applyDeedDocumentVerificationPrefill(
      this.state.master,
      checklistValues,
      repeatableValues,
      this.scrutinyApiCache,
      {
        deedMasterList: this.deedMasterListCache,
        reconcileGates: true,
        // Document (ScrutinyForm) is source of truth for mapped fields like extent.
        forceMappedFields: true,
      }
    );
    const nextChecklistValues = reconcileAllFollowUpClears(this.state.master, checklistValues);
    formatChecklistDatesInRuntime(this.state.master, {
      checklistValues: nextChecklistValues,
      repeatableValues,
      fieldVerified: this.state.fieldVerified,
    });
    this.setState(
      { checklistValues: nextChecklistValues, repeatableValues },
      () => this.emitChange()
    );
  };

  applyEcDocumentPrefill = () => {
    if (!this.scrutinyApiCache) return;
    const repeatableValues = Object.keys(this.state.repeatableValues).reduce<
      Record<string, Record<string, string>[]>
    >((acc, k) => {
      acc[k] = (this.state.repeatableValues[k] || []).map((r) => ({ ...r }));
      return acc;
    }, {});
    applyEcVerificationPrefill(
      this.state.master,
      repeatableValues,
      this.scrutinyApiCache,
      { forceEntryFields: true }
    );
    this.setState({ repeatableValues, validationMessages: [] }, () => this.emitChange());
  };

  publishApi() {
    if (!this.props.apiRef) return;
    this.props.apiRef({
      validate: this.validateVisibleChecklist,
      getValue: this.snapshotValue,
      reload: this.loadAll,
      syncMappedValues: this.syncMappedValues,
    });
  }

  snapshotValue = (): DynamicChecklistRuntimeValue => {
    const checklistValues = enrichChecklistValuesForPersist(
      this.state.master,
      this.state.checklistValues
    );
    const repeatableValues = enrichRepeatableValuesForPersist(
      this.state.master,
      this.state.repeatableValues
    );
    return {
      checklistValues,
      repeatableValues: Object.keys(repeatableValues).reduce<
        Record<string, Record<string, string>[]>
      >((acc, k) => {
        acc[k] = (repeatableValues[k] || []).map((r) => ({ ...r }));
        return acc;
      }, {}),
      fieldVerified: { ...this.state.fieldVerified },
    };
  };

  buildMappedValueUpdates = (): MappedValueUpdates => {
    const frontOfficeUpdates: Record<string, string> = {};
    const scrutinyUpdates: MappedValueUpdates["scrutinyUpdates"] = [];
    const addonScalarByTag: Record<string, string> = {};
    let propertyDetailUpdates: MappedPropertyDetailUpdates | null = null;
    const preDisbursementDocuments: AddonDisbursementDocumentUpdate[] = [];
    const postDisbursementDocuments: AddonDisbursementDocumentUpdate[] = [];
    const runtime = this.snapshotValue();

    const addFrontOffice = (f: ChecklistFieldDef, value: string | undefined) => {
      if (f.disabled) return;
      const key = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
      if (!key) return;
      if (f.dynamicValueSource !== "front_office") return;
      if (f.type !== "text" && f.type !== "date" && f.type !== "remarks") return;
      frontOfficeUpdates[key] = checklistValueForMappedSave(f, value);
    };

    const addAddonScalar = (f: ChecklistFieldDef, value: string | undefined) => {
      if (f.disabled) return;
      if (f.dynamicValueSource === "front_office") return;
      const tag = normalizeDeedIdForSelect(f.scrutinyLinkedDeedId);
      if (!tag || !ADDON_SCALAR_DYNAMIC_TAG_IDS.has(tag)) return;
      if (f.type !== "text" && f.type !== "date" && f.type !== "remarks") return;
      addonScalarByTag[tag] = checklistValueForMappedSave(f, value);
    };

    const addScrutiny = (
      f: ChecklistFieldDef,
      value: string | undefined,
      deedMasterId: number | undefined,
      rowIndex: number,
      row: Record<string, string>
    ) => {
      if (f.disabled) return;
      if (isDocumentScheduleMappedField(f)) return;
      const key = resolveScrutinyFieldSaveTag(f);
      if (!key) return;
      if (f.dynamicValueSource === "front_office") return;
      if (f.type !== "text" && f.type !== "date" && f.type !== "remarks" && f.type !== "dropdown" && f.type !== "yes_no") {
        return;
      }
      if (!deedMasterId || !Number.isFinite(Number(deedMasterId))) return;
      if (
        isOriginalPresentScrutinySaveTag(key) &&
        (f.type !== "dropdown" || isOriginalPresentYesNoValue(value))
      ) {
        return;
      }
      if (f.type === "yes_no" && isScrutinyScalarDataColumnSaveTag(key)) {
        return;
      }
      const strVal = checklistValueForMappedSave(f, value);
      // Do not write empty values back to scrutiny — avoids wiping fields not shown in the row.
      if (strVal.trim() === "") return;
      if (isOriginalPresentScrutinySaveTag(key) && isOriginalPresentYesNoValue(strVal)) {
        return;
      }
      const dsIdRaw = String(row[REPEATABLE_DS_ID_META_KEY] ?? "").trim();
      const dsId = dsIdRaw !== "" && Number.isFinite(Number(dsIdRaw)) ? Number(dsIdRaw) : undefined;
      scrutinyUpdates.push({
        deedMasterId: Number(deedMasterId),
        rowIndex,
        ...(dsId != null && dsId > 0 ? { dsId } : {}),
        mappedField: key,
        value: strVal,
      });
    };

    const pushScheduleDeedScrutinyUpdate = (
      group: ChecklistRepeatableGroupDef,
      row: Record<string, string>,
      rowIndex: number,
      deedMasterId: number | undefined
    ) => {
      if (!deedMasterId || !Number.isFinite(Number(deedMasterId))) return;
      const scheduleFields = documentScheduleFieldsInGroup(group.fields);
      if (!scheduleFields.length) return;
      const sets = collectDocumentScheduleSetsFromRow(row, scheduleFields);
      if (!sets.length) return;
      const dsIdRaw = String(row[REPEATABLE_DS_ID_META_KEY] ?? "").trim();
      const dsId =
        dsIdRaw !== "" && Number.isFinite(Number(dsIdRaw)) ? Number(dsIdRaw) : undefined;
      scrutinyUpdates.push({
        deedMasterId: Number(deedMasterId),
        rowIndex,
        ...(dsId != null && dsId > 0 ? { dsId } : {}),
        mappedField: "schedule_deed",
        value: JSON.stringify(sets),
      });
    };

    const fileBankProductId = resolveFileBankProductId(this.state.frontOfficePrefill);
    this.state.master.forEach((section) => {
      section.fields.forEach((f) => {
        addFrontOffice(f, runtime.checklistValues[f.id]);
        addAddonScalar(f, runtime.checklistValues[f.id]);
        if (
          !f.disabled &&
          isAddressOfPropertyMappedField(f) &&
          this.state.addressPropertyLines.length
        ) {
          propertyDetailUpdates = buildAddressPropertyDetailUpdates(
            runtime.checklistValues[f.id],
            this.state.addressPropertyLines
          );
        }
      });

      const preDisbursementFields = mappedFieldsForTagSet(section, PRE_DISBURSEMENT_DYNAMIC_TAG_IDS);
      const postDisbursementFields = mappedFieldsForTagSet(section, POST_DISBURSEMENT_DYNAMIC_TAG_IDS);
      const sectionPreRows = buildDisbursementDocumentUpdates(
        section,
        preDisbursementFields,
        runtime.repeatableValues,
        PRE_DISBURSEMENT_REPEATABLE_SUFFIX,
        PRE_DISBURSEMENT_META_ID_KEY,
        "preDisbursementId",
        PRE_DISBURSEMENT_TAG_TO_ROW_KEY
      );
      preDisbursementDocuments.push(...sectionPreRows);
      if (!sectionPreRows.length) {
        const standalonePre = buildStandaloneDisbursementDocumentUpdate(
          preDisbursementFields,
          runtime.checklistValues,
          PRE_DISBURSEMENT_TAG_TO_ROW_KEY
        );
        if (standalonePre) preDisbursementDocuments.push(standalonePre);
      }
      const sectionPostRows = buildDisbursementDocumentUpdates(
        section,
        postDisbursementFields,
        runtime.repeatableValues,
        POST_DISBURSEMENT_REPEATABLE_SUFFIX,
        POST_DISBURSEMENT_META_ID_KEY,
        "postDisbursementId",
        POST_DISBURSEMENT_TAG_TO_ROW_KEY
      );
      postDisbursementDocuments.push(...sectionPostRows);
      if (!sectionPostRows.length) {
        const standalonePost = buildStandaloneDisbursementDocumentUpdate(
          postDisbursementFields,
          runtime.checklistValues,
          POST_DISBURSEMENT_TAG_TO_ROW_KEY
        );
        if (standalonePost) postDisbursementDocuments.push(standalonePost);
      }

      (section.repeatableGroups || []).forEach((g) => {
        if (g.bankProductId != null) {
          if (
            fileBankProductId == null ||
            Number(g.bankProductId) !== fileBankProductId
          ) {
            return;
          }
          g.fields.forEach((f) => addFrontOffice(f, runtime.checklistValues[f.id]));
          return;
        }
        if (g.naturePropertyKey != null) {
          return;
        }
        if (g.surveyHierarchyLevel != null || g.ecHierarchyLevel != null) {
          return;
        }
        if (g.deedMasterId != null) {
          return;
        }
        const key = repeatableEntriesKey(section.id, g.id);
        const rows = runtime.repeatableValues[key] || [];
        rows.forEach((row, rowIndex) => {
          pushScheduleDeedScrutinyUpdate(g, row, rowIndex, g.deedMasterId as number | undefined);
          g.fields.forEach((f) => {
            if (isLegalHeirsMappedField(f)) {
              if (f.disabled) return;
              const names = collectLegalHeirsFromRow(row, f.id);
              if (!names.length) return;
              const dsIdRaw = String(row[REPEATABLE_DS_ID_META_KEY] ?? "").trim();
              const dsId =
                dsIdRaw !== "" && Number.isFinite(Number(dsIdRaw))
                  ? Number(dsIdRaw)
                  : undefined;
              scrutinyUpdates.push({
                deedMasterId: Number(g.deedMasterId),
                rowIndex,
                ...(dsId != null && dsId > 0 ? { dsId } : {}),
                mappedField: "legal_heirs",
                value: JSON.stringify(names),
              });
              return;
            }
            addScrutiny(f, row[f.id], g.deedMasterId as number | undefined, rowIndex, row);
          });
        });
      });

      collectDeedDocumentEntriesInSaveOrder(
        section,
        runtime.repeatableValues,
        this.scrutinyApiCache,
        this.deedMasterListCache
      ).forEach((entry) => {
        if (!deedDocumentEntryVisible(entry, runtime.checklistValues)) return;
        const { group, row, rowIndex } = entry;
        pushScheduleDeedScrutinyUpdate(
          group,
          row,
          rowIndex,
          group.deedMasterId as number | undefined
        );
        group.fields.forEach((f) => {
          if (isLegalHeirsMappedField(f)) {
            if (f.disabled) return;
            const names = collectLegalHeirsFromRow(row, f.id);
            if (!names.length) return;
            const dsIdRaw = String(row[REPEATABLE_DS_ID_META_KEY] ?? "").trim();
            const dsId =
              dsIdRaw !== "" && Number.isFinite(Number(dsIdRaw))
                ? Number(dsIdRaw)
                : undefined;
            scrutinyUpdates.push({
              deedMasterId: Number(group.deedMasterId),
              rowIndex,
              ...(dsId != null && dsId > 0 ? { dsId } : {}),
              mappedField: "legal_heirs",
              value: JSON.stringify(names),
            });
            return;
          }
          addScrutiny(f, row[f.id], group.deedMasterId as number | undefined, rowIndex, row);
        });
      });
    });

    const surveyNatureKeys = resolveSurveyNaturePropertyKeys(
      this.state.frontOfficePrefill,
      this.state.propertyDetailsPrefill,
      this.state.generalDetailsByDocument,
      null
    );
    const ecVerificationUpdates = buildEcVerificationUpdates(
      this.state.master,
      runtime.repeatableValues
    );
    const surveyVerificationUpdates = buildSurveyVerificationUpdates(
      this.state.master,
      runtime.checklistValues,
      runtime.repeatableValues,
      {
        // File-level: do not pin write-back to the preview-selected document.
        activeDocumentFdId: null,
        naturePropertyKeys: surveyNatureKeys,
        scrutinyApiData: this.scrutinyApiCache,
        generalDetailsByDocument: this.state.generalDetailsByDocument,
      }
    );

    return {
      frontOfficeUpdates: Object.keys(frontOfficeUpdates).map((field) => ({
        field,
        value: frontOfficeUpdates[field],
      })),
      scrutinyUpdates,
      propertyDetailUpdates,
      addonFeatureUpdates: Object.keys(addonScalarByTag).map((field) => ({
        field,
        value: addonScalarByTag[field],
      })),
      preDisbursementDocuments,
      postDisbursementDocuments,
      ecVerificationUpdates,
      surveyVerificationUpdates,
    };
  };

  syncMappedValues = () => {
    if (!this.props.fileId) return Promise.resolve();
    const updates = this.buildMappedValueUpdates();
    const propertyDetailUpdates = updates.propertyDetailUpdates;
    const hasPropertyDetailUpdates =
      propertyDetailUpdates != null && propertyDetailUpdates.addressLines.length > 0;
    if (
      !updates.frontOfficeUpdates.length &&
      !updates.scrutinyUpdates.length &&
      !hasPropertyDetailUpdates &&
      !updates.addonFeatureUpdates.length &&
      !updates.preDisbursementDocuments.length &&
      !updates.postDisbursementDocuments.length &&
      !updates.ecVerificationUpdates.blocks.length &&
      !updates.ecVerificationUpdates.entries.length &&
      !updates.surveyVerificationUpdates.hierarchyRows.length &&
      !updates.surveyVerificationUpdates.flatByFdId.length &&
      !updates.surveyVerificationUpdates.natureScoped.length
    ) {
      return Promise.resolve();
    }
    const userRaw = localStorage.getItem("user");
    const userId = userRaw ? JSON.parse(userRaw)["userId"] : "";
    const payload: Record<string, unknown> = {
      fileNo: this.props.fileId,
      loginId: userId,
      frontOfficeUpdates: updates.frontOfficeUpdates,
      scrutinyUpdates: updates.scrutinyUpdates,
      addonFeatureUpdates: updates.addonFeatureUpdates,
      preDisbursementDocuments: updates.preDisbursementDocuments,
      postDisbursementDocuments: updates.postDisbursementDocuments,
      ecVerificationUpdates: updates.ecVerificationUpdates,
      surveyVerificationUpdates: updates.surveyVerificationUpdates,
    };
    if (hasPropertyDetailUpdates) {
      payload.propertyDetailUpdates = propertyDetailUpdates;
    }
    return callApi("POST", "dynamic_checklist_mapped_values_save.php", payload)
      .then((res) => res?.data)
      .then((data) => {
        if (data && data.result === false) {
          const detail =
            Array.isArray(data.errors) && data.errors.length
              ? data.errors.join("; ")
              : "Mapped value sync failed";
          return Promise.reject(new Error(detail));
        }
      })
      .then(() => undefined);
  };

  emitChange(state?: Partial<RuntimeState>) {
    if (!this.props.onChange) return;
    const merged: RuntimeState = { ...this.state, ...(state || {}) };
    this.props.onChange({
      checklistValues: { ...merged.checklistValues },
      repeatableValues: Object.keys(merged.repeatableValues).reduce<
        Record<string, Record<string, string>[]>
      >((acc, k) => {
        acc[k] = (merged.repeatableValues[k] || []).map((r) => ({ ...r }));
        return acc;
      }, {}),
      fieldVerified: { ...merged.fieldVerified },
    });
  }

  loadScrutinyChecklist = (): Promise<{ scrutinyData: any; deedMasterList: DeedMasterRowLite[] }> => {
    if (!this.props.fileId) {
      return Promise.resolve({ scrutinyData: {}, deedMasterList: [] });
    }
    const userRaw = localStorage.getItem("user");
    const userId = userRaw ? JSON.parse(userRaw)["userId"] : "";
    return Promise.all([
      fetchScrutinyChecklistForFile(this.props.fileId, userId),
      fetchDeedMasterList(),
    ]).then(([scrutinyData, deedMasterList]) => ({ scrutinyData, deedMasterList }));
  };

  applyScrutinyPrefillToRuntime(
    master: ChecklistSectionDef[],
    merged: DynamicChecklistRuntimeValue,
    scrutinyData: any,
    deedMasterList: DeedMasterRowLite[]
  ): void {
    const autoOpenDeedGates = !hasPersistedDynamicSnapshot(
      this.props.initialValue,
      this.props.persistedSnapshot
    );
    applyScrutinyTagPrefill(master, merged, scrutinyData, {
      autoOpenDeedGates,
      deedMasterList,
      activeDocumentFdId: this.props.activeDocumentFdId ?? null,
    });
    formatChecklistDatesInRuntime(master, merged);
  }

  /**
   * Build runtime values from master + saved snapshot. When a saved snapshot
   * exists, restore it without re-running document/scrutiny prefill (which
   * rebuilds hierarchy rows and can wipe typed answers).
   */
  assembleMergedRuntime(
    master: ChecklistSectionDef[],
    frontOfficeRow: Record<string, string>,
    scrutinyData: any,
    deedMasterList: DeedMasterRowLite[],
    initialValue?: Partial<DynamicChecklistRuntimeValue> | null,
    persistedSnapshot?: boolean
  ): DynamicChecklistRuntimeValue {
    const repeatableValues = emptyRepeatableValuesFromMaster(master);
    const seeded: DynamicChecklistRuntimeValue = {
      checklistValues: emptyValuesFromMaster(master),
      repeatableValues,
      fieldVerified: initWorkFileFieldVerified(master, repeatableValues),
    };
    const merged = mergeInitial(seeded, initialValue || null);
    merged.fieldVerified = mergeFieldVerifiedWithMaster(
      master,
      merged.repeatableValues,
      merged.fieldVerified
    );

    const restoreSaved = hasPersistedDynamicSnapshot(initialValue, persistedSnapshot);
    if (restoreSaved) {
      restoreRepeatableHierarchyFieldsFromPersist(master, merged.repeatableValues);
      restoreNatureScopedFieldsFromPersist(master, merged.checklistValues);
    }
    if (restoreSaved) {
      merged.checklistValues = rebuildChecklistValuesFromPersist(
        master,
        merged.checklistValues,
        scrutinyData,
        frontOfficeRow
      );
    } else {
      merged.checklistValues = applyFrontOfficePrefill(
        master,
        merged.checklistValues,
        frontOfficeRow
      );
    }

    if (!restoreSaved) {
      this.applyScrutinyPrefillToRuntime(master, merged, scrutinyData, deedMasterList);
      merged.fieldVerified = mergeFieldVerifiedWithMaster(
        master,
        merged.repeatableValues,
        merged.fieldVerified
      );
      merged.checklistValues = reconcileAllFollowUpClears(master, merged.checklistValues);
      seedRepeatableRowFollowUpKeys(master, merged.repeatableValues, merged.checklistValues);
      if (scrutinyData) {
        const missingLodRows = Array.isArray(scrutinyData?.missingLOD?.sheets)
          ? (scrutinyData.missingLOD.sheets as any[]).map((r: any) => {
              const row: Record<string, string> = {};
              if (r && typeof r === "object") {
                Object.keys(r).forEach((k) => {
                  const v = r[k];
                  if (v != null && typeof v !== "object") row[k] = String(v).trim();
                });
              }
              return row;
            })
          : [];
        applyScrutinyFollowUpPrefill(
          master,
          merged.checklistValues,
          merged.repeatableValues,
          scrutinyData,
          deedMasterList,
          missingLodRows
        );
      }
      merged.checklistValues = reconcileRepeatableRowFollowUpClears(
        master,
        merged.repeatableValues,
        merged.checklistValues
      );
    } else {
      formatChecklistDatesInRuntime(master, merged);
      merged.checklistValues = preserveFollowUpDefaultsInChecklist(
        master,
        merged.checklistValues
      );
      seedRepeatableRowFollowUpKeys(master, merged.repeatableValues, merged.checklistValues);
      // Saved checklist must not block document edits: re-sync mapped deed fields
      // (e.g. Patta extent) and survey hierarchy from current scrutiny/GD.
      if (scrutinyData) {
        applyDeedDocumentVerificationPrefill(
          master,
          merged.checklistValues,
          merged.repeatableValues,
          scrutinyData,
          {
            deedMasterList,
            reconcileGates: true,
            forceMappedFields: true,
          }
        );
        applySurveyVerificationPrefill(
          master,
          merged.checklistValues,
          merged.repeatableValues,
          scrutinyData,
          {
            activeDocumentFdId: this.props.activeDocumentFdId ?? null,
            propertyDetails:
              scrutinyData?.propertyDetails && typeof scrutinyData.propertyDetails === "object"
                ? Object.keys(scrutinyData.propertyDetails).reduce<Record<string, string>>(
                    (acc, k) => {
                      const v = (scrutinyData.propertyDetails as any)[k];
                      acc[k] = v == null ? "" : String(v);
                      return acc;
                    },
                    {}
                  )
                : null,
            generalDetailsByDocument:
              scrutinyData?.generalDetailsByDocument &&
              typeof scrutinyData.generalDetailsByDocument === "object"
                ? scrutinyData.generalDetailsByDocument
                : null,
            forceHierarchyFields: true,
          }
        );
        formatChecklistDatesInRuntime(master, merged);
      }
    }

    return merged;
  }

  loadAll = () => {
    this.setState({ masterLoading: true, loadError: null });
    Promise.all([this.loadMaster(), this.loadFrontOffice(), this.loadScrutinyChecklist()])
      .then(([master, frontOfficeRow, scrutinyBundle]) => {
        const scrutinyData = scrutinyBundle.scrutinyData;
        const deedMasterList = scrutinyBundle.deedMasterList;
        this.scrutinyApiCache = scrutinyData;
        this.deedMasterListCache = deedMasterList;
        const merged = this.assembleMergedRuntime(
          master,
          frontOfficeRow,
          scrutinyData,
          deedMasterList,
          this.props.initialValue,
          this.props.persistedSnapshot
        );

        const sectionUiOpen = runtimeInitSectionOpen(master);
        const addressPropertyLines = parseAddressPropertyLineMeta(scrutinyData);
        const generalDetailsByDocument =
          scrutinyData?.generalDetailsByDocument &&
          typeof scrutinyData.generalDetailsByDocument === "object"
            ? (scrutinyData.generalDetailsByDocument as Record<
                string,
                GeneralDetailsDocumentHierarchy
              >)
            : {};
        const propertyDetailsPrefill =
          scrutinyData?.propertyDetails && typeof scrutinyData.propertyDetails === "object"
            ? Object.keys(scrutinyData.propertyDetails).reduce<Record<string, string>>(
                (acc, k) => {
                  const v = (scrutinyData.propertyDetails as any)[k];
                  acc[k] = v == null ? "" : String(v);
                  return acc;
                },
                {}
              )
            : {};
        const hasSavedSnapshot = hasPersistedDynamicSnapshot(
          this.props.initialValue,
          this.props.persistedSnapshot
        );
        this.setState(
          {
            master,
            checklistValues: merged.checklistValues,
            repeatableValues: merged.repeatableValues,
            fieldVerified: merged.fieldVerified,
            sectionUiOpen,
            frontOfficePrefill: frontOfficeRow,
            addressPropertyLines,
            generalDetailsByDocument,
            propertyDetailsPrefill,
            masterLoading: false,
            loadError: null,
          },
          () => {
            if (!hasSavedSnapshot) {
              this.applySurveyDocumentPrefill();
              this.applyEcDocumentPrefill();
            } else {
              this.applyPersistedDocumentPrefill();
            }
            this.emitChange();
            this.publishApi();
            if (this.props.onLoaded) {
              this.props.onLoaded(this.snapshotValue(), master);
            }
          }
        );
      })
      .catch(() => {
        this.setState({
          masterLoading: false,
          loadError: "Could not load dynamic checklist. Please retry.",
        });
      });
  };

  loadMaster = (): Promise<ChecklistSectionDef[]> => {
    return callApi("POST", "dynamic_checklist_master_get.php")
      .then((res) => res?.data)
      .then((response) => {
        const data = response?.data;
        if (response?.result === false || !data) return [];
        const raw = Array.isArray(data.master) ? data.master : [];
        return normalizeMasterFromApi(raw as ChecklistSectionDef[]);
      })
      .catch(() => [] as ChecklistSectionDef[]);
  };

  loadFrontOffice = (): Promise<Record<string, string>> => {
    if (!this.props.fileId) return Promise.resolve({});
    return callApi("POST", "front_office_get.php", { id: this.props.fileId })
      .then((res) => res?.data)
      .then((response) => {
        const arr = response?.data?.[0]?.arr;
        if (!Array.isArray(arr) || !arr.length) return {} as Record<string, string>;
        const row = arr[0] || {};
        const out: Record<string, string> = {};
        Object.keys(row).forEach((k) => {
          const v = row[k];
          out[k] = v == null ? "" : String(v);
        });
        if (response?.data?.[0]?.contact_number != null) {
          out["contact_number"] = String(response.data[0].contact_number);
        }
        if (response?.data?.[0]?.loan_amount != null) {
          out["loan_amount"] = String(response.data[0].loan_amount);
        }
        if (response?.data?.[0]?.property_owner_name != null) {
          out["property_owner_name"] = String(response.data[0].property_owner_name);
        }
        return out;
      })
      .catch(() => ({}));
  };

  /**
   * Re-apply `initialValue` over the currently seeded state without re-fetching
   * the master. Used when the parent updates `initialValue` after a save.
   */
  applyInitialValue() {
    const { master, frontOfficePrefill } = this.state;
    if (!master.length) return;
    this.loadScrutinyChecklist().then(({ scrutinyData, deedMasterList }) => {
      this.scrutinyApiCache = scrutinyData;
      this.deedMasterListCache = deedMasterList;
      const merged = this.assembleMergedRuntime(
        master,
        frontOfficePrefill,
        scrutinyData,
        deedMasterList,
        this.props.initialValue,
        this.props.persistedSnapshot
      );
      const hasSavedSnapshot = hasPersistedDynamicSnapshot(
        this.props.initialValue,
        this.props.persistedSnapshot
      );
      this.setState({ addressPropertyLines: parseAddressPropertyLineMeta(scrutinyData) }, () =>
        this.commitMergedRuntimeState(merged, master, () => {
          if (!hasSavedSnapshot) {
            this.applySurveyDocumentPrefill();
            this.applyEcDocumentPrefill();
          } else {
            this.applyPersistedDocumentPrefill();
          }
        })
      );
    });
  }

  commitMergedRuntimeState(
    merged: DynamicChecklistRuntimeValue,
    master: ChecklistSectionDef[],
    afterCommit?: () => void
  ) {
    this.setState(
      {
        checklistValues: merged.checklistValues,
        repeatableValues: merged.repeatableValues,
        fieldVerified: merged.fieldVerified,
      },
      () => {
        this.emitChange();
        afterCommit?.();
      }
    );
  }

  setChecklistValue = (fieldId: string, value: string) => {
    this.setState(
      (prev) => {
        const fieldDef = collectAllChecklistFieldsFromMaster(prev.master).find(
          (f) => f.id === fieldId
        );
        let nextValue = value;
        if (fieldDef && isMissingSheetsField(fieldDef)) {
          nextValue = normalizeMissingSheetsScalar(value);
        }
        let next = { ...prev.checklistValues, [fieldId]: nextValue };
        if (prev.checklistValues[fieldId] !== nextValue) {
          next = reconcileAllFollowUpClears(prev.master, next);
          prev.master.forEach((section) => {
            reconcileMissingSheetsInFieldRow(section.fields || [], next);
          });
        }
        return { checklistValues: next, validationMessages: [] } as Pick<
          RuntimeState,
          "checklistValues" | "validationMessages"
        >;
      },
      () => this.emitChange()
    );
  };

  setFieldVerified = (fieldId: string, checked: boolean) => {
    this.setState(
      (prev) => ({
        fieldVerified: { ...prev.fieldVerified, [fieldId]: checked ? "true" : "false" },
      }),
      () => this.emitChange()
    );
  };

  toggleSectionOpen = (sectionId: string) => {
    this.setState((prev) => {
      const isOpen = prev.sectionUiOpen[sectionId] === true;
      const sectionUiOpen: Record<string, boolean> = { ...prev.sectionUiOpen };
      prev.master.forEach((section) => {
        sectionUiOpen[section.id] = false;
      });
      if (!isOpen) {
        sectionUiOpen[sectionId] = true;
      }
      return { sectionUiOpen };
    });
  };

  onSectionHeaderKeyDown = (sectionId: string, e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.toggleSectionOpen(sectionId);
    }
  };

  setRepeatableCell = (
    sectionId: string,
    groupId: string,
    rowIndex: number,
    fieldId: string,
    value: string
  ) => {
    const key = repeatableEntriesKey(sectionId, groupId);
    const rows = [...(this.state.repeatableValues[key] || [])];
    if (!rows[rowIndex]) return;
    const prevValue = rows[rowIndex][fieldId];
    const nextRows = [...rows];
    const fieldDef = findFieldInMaster(this.state.master, sectionId, groupId, fieldId);
    let nextValue = value;
    if (fieldDef && isMissingSheetsField(fieldDef)) {
      nextValue = normalizeMissingSheetsScalar(value);
    }
    nextRows[rowIndex] = { ...nextRows[rowIndex], [fieldId]: nextValue };
    const group = this.state.master
      .flatMap((s) => s.repeatableGroups || [])
      .find((g) => g.id === groupId);
    if (group) {
      reconcileMissingSheetsInFieldRow(group.fields || [], nextRows[rowIndex]);
    }
    this.setState(
      (prev) => {
        let checklistValues = prev.checklistValues;
        if (prevValue !== nextValue) {
          const fieldDefInner = findFieldInMaster(prev.master, sectionId, groupId, fieldId);
          if (
            fieldDefInner &&
            fieldDefInner.optionFollowUps?.length &&
            fieldTypeSupportsOptionFollowUps(fieldDefInner.type)
          ) {
            const scopedKey = (vk: string) =>
              repeatableRowFollowUpStorageKey(sectionId, groupId, rowIndex, vk);
            checklistValues = applyConditionalFollowUpClearForParentValue(
              fieldDefInner,
              nextValue,
              checklistValues,
              scopedKey
            );
          }
        }
        return {
          repeatableValues: { ...prev.repeatableValues, [key]: nextRows },
          checklistValues,
          validationMessages: [],
        };
      },
      () => this.emitChange()
    );
  };

  /**
   * Mirrors the master tab's "Validate & save" pass: returns one missing-field
   * message per required field (or required follow-up) that is currently
   * visible but empty.
   */
  validateVisibleChecklist = (): string[] => {
    const missing: string[] = [];
    const sections = sortSections(this.state.master);

    const checkVal = (f: ChecklistFieldDef, val: string | undefined): boolean => {
      if (!f.required || f.disabled) return true;
      return isChecklistAnswerFilled(f.type, val);
    };

    sections.forEach((s) => {
      const groupFieldIds = fieldIdsInDeedGroups(s);
      const missingLodFields = this.missingLodMappedFields(s);
      const preDisbursementFields = mappedFieldsForTagSet(s, PRE_DISBURSEMENT_DYNAMIC_TAG_IDS);
      const postDisbursementFields = mappedFieldsForTagSet(s, POST_DISBURSEMENT_DYNAMIC_TAG_IDS);
      const missingLodFieldIds = new Set(missingLodFields.map((f) => f.id));
      const preDisbursementFieldIds = new Set(preDisbursementFields.map((f) => f.id));
      const postDisbursementFieldIds = new Set(postDisbursementFields.map((f) => f.id));
      const gateIds = new Set(sectionGateFields(s).map((g) => g.id));
      const sectionStandaloneFields = s.fields.filter(
        (f) => !gateIds.has(f.id) && !groupFieldIds.has(f.id)
      );
      const missingLodRows =
        this.state.repeatableValues[repeatableEntriesKey(s.id, MISSING_LOD_REPEATABLE_SUFFIX)] || [];
      const preDisbursementRows =
        this.state.repeatableValues[repeatableEntriesKey(s.id, PRE_DISBURSEMENT_REPEATABLE_SUFFIX)] ||
        [];
      const postDisbursementRows =
        this.state.repeatableValues[repeatableEntriesKey(s.id, POST_DISBURSEMENT_REPEATABLE_SUFFIX)] ||
        [];
      const useMissingLodRows = missingLodFields.length > 0 && missingLodRows.length > 0;
      const usePreDisbursementRows =
        preDisbursementFields.length > 0 && preDisbursementRows.length > 0;
      const usePostDisbursementRows =
        postDisbursementFields.length > 0 && postDisbursementRows.length > 0;
      const autoRepeatableFieldIds = new Set<string>([
        ...(useMissingLodRows ? missingLodFieldIds : []),
        ...(usePreDisbursementRows ? preDisbursementFieldIds : []),
        ...(usePostDisbursementRows ? postDisbursementFieldIds : []),
      ]);
      s.fields.forEach((f) => {
        if (groupFieldIds.has(f.id)) return;
        if (autoRepeatableFieldIds.has(f.id)) return;
        if (!useMissingLodRows && missingLodFieldIds.has(f.id)) return;
        if (!usePreDisbursementRows && preDisbursementFieldIds.has(f.id)) return;
        if (!usePostDisbursementRows && postDisbursementFieldIds.has(f.id)) return;
        if (!checkVal(f, this.state.checklistValues[f.id])) {
          missing.push(`${s.title} → ${f.label}`);
        }
        if (fieldHasConfiguredFollowUps(f)) {
          const branch = triggerFollowBranchKey(f, this.state.checklistValues);
          if (f.type === "dropdown" && !branch) return;
          collectVisibleFollowUpValidationMissing(
            f.optionFollowUps!,
            branch,
            f.type,
            this.state.checklistValues,
            `${s.title} → ${f.label}`,
            missing,
            f.disabled
          );
        }
      });
      const fileBankProductId = resolveFileBankProductId(this.state.frontOfficePrefill);
      const surveyNatureKeys = resolveSurveyNaturePropertyKeys(
        this.state.frontOfficePrefill,
        this.state.propertyDetailsPrefill,
        this.state.generalDetailsByDocument,
        null
      );
      (s.repeatableGroups || []).forEach((g) => {
        if (g.bankProductId != null) {
          if (
            fileBankProductId == null ||
            Number(g.bankProductId) !== fileBankProductId
          ) {
            return;
          }
          g.fields.forEach((f) => {
            if (!checkVal(f, this.state.checklistValues[f.id])) {
              missing.push(`${s.title} → ${g.label} → ${f.label}`);
            }
            if (fieldHasConfiguredFollowUps(f)) {
              const branch = triggerFollowBranchKey(f, this.state.checklistValues);
              if (f.type === "dropdown" && !branch) return;
              collectVisibleFollowUpValidationMissing(
                f.optionFollowUps!,
                branch,
                f.type,
                this.state.checklistValues,
                `${s.title} → ${g.label} → ${f.label}`,
                missing,
                f.disabled
              );
            }
          });
          return;
        }
        if (g.naturePropertyKey != null) {
          const visibleNatureGroups = resolveVisibleSurveyNatureGroups(s, surveyNatureKeys);
          if (!visibleNatureGroups.some((vg) => vg.id === g.id)) return;
          const hasHierarchyNature = surveyHierarchyLinkedGroups(s).some((hg) => hg.fields.length > 0);
          const scheduleGroupForNature = surveyHierarchyGroupForLevel(
            s,
            "schedule",
            g.naturePropertyKey
          );
          const scheduleHasChecklistFields = surveyHierarchyGroupHasChecklistFields(
            scheduleGroupForNature
          );
          const hierarchyFieldIdsForNature = new Set<string>(
            surveyHierarchyLinkedGroups(s, g.naturePropertyKey).flatMap((hg) =>
              (hg.fields || []).map((f) => f.id)
            )
          );
          const fdId =
            resolveSurveyDocumentFdId(this.props.activeDocumentFdId, this.scrutinyApiCache) ||
            String(this.props.activeDocumentFdId ?? "").trim();
          if (hasHierarchyNature && fdId) {
            // Management may keep hierarchy but remove all Schedule-level checklist
            // fields. In that case, do not validate legacy nature-scoped schedule fields.
            if (!scheduleHasChecklistFields) return;
            const docSchedules = this.state.generalDetailsByDocument[fdId]?.schedules ?? [];
            docSchedules.forEach((sched, schedIdx) => {
              const schedNature = matchNaturePropertyKey(sched.nature_doc ?? "");
              if (schedNature !== g.naturePropertyKey) return;
              const schedId = String(sched.id ?? "").trim();
              if (!schedId) return;
              g.fields.forEach((f) => {
                if (hierarchyFieldIdsForNature.has(f.id)) return;
                const scopedKey = surveyNatureFieldScopeKey(fdId, schedId, f.id);
                const readScoped = (fieldId: string) =>
                  this.state.checklistValues[surveyNatureFieldScopeKey(fdId, schedId, fieldId)] ??
                  "";
                const surveyType = resolveSurveyTypeFromHierarchyRow(
                  g.fields,
                  {},
                  sched.survey_details?.[0]?.survey_type ?? null,
                  readScoped
                );
                const sd = sched.survey_details?.[0];
                const surveyPrefillRow: Record<string, string> = sd
                  ? {
                      survey_type: String(sd.survey_type ?? "").trim(),
                      ts_old_survey_no: String(sd.ts_old_survey_no ?? "").trim(),
                      ts_old_ts_no: String(sd.ts_old_ts_no ?? "").trim(),
                      old_ts_s_no: String(sd.old_ts_s_no ?? "").trim(),
                      old_ts_no: String(sd.old_ts_no ?? "").trim(),
                    }
                  : {};
                if (!isSurveyFieldVisibleForSurveyType(f, surveyType, surveyPrefillRow)) return;
                const parentVal = this.state.checklistValues[scopedKey];
                if (!checkVal(f, parentVal)) {
                  missing.push(
                    `${s.title} → ${g.label} → Schedule ${scheduleDisplayNumber(sched, schedIdx)} → ${f.label}`
                  );
                }
                if (fieldHasConfiguredFollowUps(f)) {
                  const branch = triggerFollowBranchKeyForValue(f, parentVal);
                  if (f.type === "dropdown" && !branch) return;
                  const storageKey = (vk: string) =>
                    surveyNatureFieldScopeKey(fdId, schedId, vk);
                  collectVisibleFollowUpValidationMissing(
                    f.optionFollowUps!,
                    branch,
                    f.type,
                    this.state.checklistValues,
                    `${s.title} → ${g.label} → Schedule ${scheduleDisplayNumber(sched, schedIdx)} → ${f.label}`,
                    missing,
                    f.disabled,
                    storageKey
                  );
                }
              });
            });
            return;
          }
          g.fields.forEach((f) => {
            if (hierarchyFieldIdsForNature.has(f.id)) return;
            if (!checkVal(f, this.state.checklistValues[f.id])) {
              missing.push(`${s.title} → ${g.label} → ${f.label}`);
            }
            if (fieldHasConfiguredFollowUps(f)) {
              const branch = triggerFollowBranchKey(f, this.state.checklistValues);
              if (f.type === "dropdown" && !branch) return;
              collectVisibleFollowUpValidationMissing(
                f.optionFollowUps!,
                branch,
                f.type,
                this.state.checklistValues,
                `${s.title} → ${g.label} → ${f.label}`,
                missing,
                f.disabled
              );
            }
          });
          return;
        }
        if (g.surveyHierarchyLevel != null) {
          const fdId = String(this.props.activeDocumentFdId ?? "").trim();
          if (!fdId) return;
          const filtered = hierarchyRowsForDocument(
            s.id,
            g.id,
            fdId,
            this.state.repeatableValues
          );
          filtered.forEach(({ row, rowIndex }) => {
            const surveyType = resolveSurveyTypeFromHierarchyRow(g.fields, row);
            g.fields.forEach((f) => {
              if (!isSurveyFieldVisibleForSurveyType(f, surveyType, row)) return;
              if (!checkVal(f, row[f.id])) {
                missing.push(`${s.title} → ${g.label} #${rowIndex + 1} → ${f.label}`);
              }
              if (fieldHasConfiguredFollowUps(f)) {
                const branch = triggerFollowBranchKeyForValue(f, row[f.id]);
                if (f.type === "dropdown" && !branch) return;
                const storageKey = (vk: string) =>
                  repeatableRowFollowUpStorageKey(s.id, g.id, rowIndex, vk);
                collectVisibleFollowUpValidationMissing(
                  f.optionFollowUps!,
                  branch,
                  f.type,
                  this.state.checklistValues,
                  `${s.title} → ${g.label} #${rowIndex + 1} → ${f.label}`,
                  missing,
                  f.disabled,
                  storageKey
                );
              }
            });
          });
          return;
        }
        if (g.ecHierarchyLevel === "ec_entry") {
          const key = repeatableEntriesKey(s.id, g.id);
          const rows = this.state.repeatableValues[key] || [];
          rows.forEach((row, idx) => {
            if (row[EC_HIERARCHY_META.RELATED] !== "true") return;
            g.fields.forEach((f) => {
              if (!checkVal(f, row[f.id])) {
                missing.push(
                  `${s.title} → Entry #${row[EC_HIERARCHY_META.LINE_INDEX] ?? idx + 1} → ${f.label}`
                );
              }
              if (fieldHasConfiguredFollowUps(f)) {
                const branch = triggerFollowBranchKeyForValue(f, row[f.id]);
                if (f.type === "dropdown" && !branch) return;
                const storageKey = (vk: string) =>
                  repeatableRowFollowUpStorageKey(s.id, g.id, idx, vk);
                collectVisibleFollowUpValidationMissing(
                  f.optionFollowUps!,
                  branch,
                  f.type,
                  this.state.checklistValues,
                  `${s.title} → Entry #${row[EC_HIERARCHY_META.LINE_INDEX] ?? idx + 1} → ${f.label}`,
                  missing,
                  f.disabled,
                  storageKey
                );
              }
            });
          });
          return;
        }
        if (g.ecHierarchyLevel === "ec_block") {
          const key = repeatableEntriesKey(s.id, g.id);
          const rows = this.state.repeatableValues[key] || [];
          rows.forEach((row, idx) => {
            g.fields.forEach((f) => {
              if (!checkVal(f, row[f.id])) {
                missing.push(`${s.title} → EC #${idx + 1} → ${f.label}`);
              }
              if (fieldHasConfiguredFollowUps(f)) {
                const branch = triggerFollowBranchKeyForValue(f, row[f.id]);
                if (f.type === "dropdown" && !branch) return;
                const storageKey = (vk: string) =>
                  repeatableRowFollowUpStorageKey(s.id, g.id, idx, vk);
                collectVisibleFollowUpValidationMissing(
                  f.optionFollowUps!,
                  branch,
                  f.type,
                  this.state.checklistValues,
                  `${s.title} → EC #${idx + 1} → ${f.label}`,
                  missing,
                  f.disabled,
                  storageKey
                );
              }
            });
          });
          return;
        }
        if (g.gateFieldId) {
          const gateVal = this.state.checklistValues[g.gateFieldId] ?? "No";
          if (gateVal !== "Yes") return;
        }
        const key = repeatableEntriesKey(s.id, g.id);
        const rows = this.state.repeatableValues[key] || [];
        rows.forEach((row, idx) => {
          g.fields.forEach((f) => {
            if (isLegalHeirsMappedField(f)) {
              if (!f.required || f.disabled) return;
              const count = getLegalHeirInputCount(row, f.id);
              for (let hi = 0; hi < count; hi++) {
                const heirVal = row[legalHeirValueKey(f.id, hi)] ?? "";
                if (!checkVal(f, heirVal)) {
                  missing.push(
                    `${s.title} → ${g.label} #${idx + 1} → ${f.label} #${hi + 1}`
                  );
                }
              }
              return;
            }
            if (isDocumentScheduleMappedField(f)) {
              const scheduleFields = documentScheduleFieldsInGroup(g.fields);
              const setCount = getDocumentScheduleSetCount(row, scheduleFields);
              for (let setIdx = 0; setIdx < setCount; setIdx++) {
                const setVal = row[documentScheduleSetValueKey(f.id, setIdx)];
                if (!checkVal(f, setVal)) {
                  const setPath = setCount > 1 ? ` → Schedule Set #${setIdx + 1}` : "";
                  missing.push(`${s.title} → ${g.label} #${idx + 1}${setPath} → ${f.label}`);
                }
              }
            } else if (!checkVal(f, row[f.id])) {
              missing.push(`${s.title} → ${g.label} #${idx + 1} → ${f.label}`);
            }
            if (fieldHasConfiguredFollowUps(f)) {
              const branch = triggerFollowBranchKeyForValue(f, row[f.id]);
              if (f.type === "dropdown" && !branch) return;
              const storageKey = (vk: string) =>
                repeatableRowFollowUpStorageKey(s.id, g.id, idx, vk);
              collectVisibleFollowUpValidationMissing(
                f.optionFollowUps!,
                branch,
                f.type,
                this.state.checklistValues,
                `${s.title} → ${g.label} #${idx + 1} → ${f.label}`,
                missing,
                f.disabled,
                storageKey
              );
            }
          });
        });
      });
      if (useMissingLodRows) {
        missingLodRows.forEach((row, idx) => {
          sectionStandaloneFields.forEach((f) => {
            if (!checkVal(f, row[f.id])) {
              missing.push(`${s.title} → Entry #${idx + 1} → ${f.label}`);
            }
          });
        });
      } else {
        missingLodRows.forEach((row, idx) => {
          missingLodFields.forEach((f) => {
            if (!checkVal(f, row[f.id])) {
              missing.push(`${s.title} → Entry #${idx + 1} → ${f.label}`);
            }
          });
        });
      }
      if (usePreDisbursementRows) {
        preDisbursementRows.forEach((row, idx) => {
          preDisbursementFields.forEach((f) => {
            if (!checkVal(f, row[f.id])) {
              missing.push(`${s.title} → Pre Disbursement #${idx + 1} → ${f.label}`);
            }
          });
        });
      }
      if (usePostDisbursementRows) {
        postDisbursementRows.forEach((row, idx) => {
          postDisbursementFields.forEach((f) => {
            if (!checkVal(f, row[f.id])) {
              missing.push(`${s.title} → Post Disbursement #${idx + 1} → ${f.label}`);
            }
          });
        });
      }
    });

    this.setState({ validationMessages: missing });
    return missing;
  };

  frontOfficeHintForField = (field: ChecklistFieldDef) => {
    if (field.dynamicValueSource !== "front_office") return null;
    const id = normalizeDeedIdForSelect(field.scrutinyLinkedDeedId);
    if (!id) return null;
    const catalog = FRONT_OFFICE_CATALOG.find((c) => c.id === id);
    const label = catalog?.name ?? id;
    const fromTitleDeed = FRONT_OFFICE_TITLE_DEED_SOURCE_IDS.has(id);
    return {
      text: ` (from Front Office: ${label})`,
      title: fromTitleDeed
        ? `Aggregated from title deed info — populated from front_office_get.php`
        : `Bound to TBL_FRONTOFFICE.${id} — populated from front_office_get.php`,
    };
  };

  scrutinyMappedHintForField = (field: ChecklistFieldDef) => {
    if (field.dynamicValueSource === "front_office") return null;
    if (!isAddressOfPropertyMappedField(field)) return null;
    if (!this.state.addressPropertyLines.length) return null;
    const docCount = this.state.addressPropertyLines.length;
    return {
      text: ` (updates General Detail on ${docCount} document${docCount === 1 ? "" : "s"} when saved)`,
      title:
        "Each address line maps to tbl_general_details for the linked scrutiny document. Saving the checklist writes changes back to those records.",
    };
  };

  renderVerifyCheckbox(verifyKey: string, ariaLabel: string) {
    return (
      <Form.Check
        type="checkbox"
        className="dvc-verify-checkbox"
        checked={this.state.fieldVerified[verifyKey] === "true"}
        onChange={(e) => this.setFieldVerified(verifyKey, e.target.checked)}
        aria-label={ariaLabel}
        title="Verification"
      />
    );
  }

  renderFieldWithVerify(
    field: ChecklistFieldDef,
    input: React.ReactNode,
    verifyKey: string
  ) {
    if (field.disabled || !workFileFieldShowsVerify(field)) return input;
    return (
      <div className="dvc-general-input-row">
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          {input}
        </div>
        {this.renderVerifyCheckbox(verifyKey, `Verified: ${field.label}`)}
      </div>
    );
  }

  renderAddressOfPropertyInputs(
    field: ChecklistFieldDef,
    storedValue: string,
    onStoredChange: (next: string) => void,
    isDisabled = false
  ) {
    let lines = parseAddressOfPropertyStored(storedValue);
    const metaCount = this.state.addressPropertyLines.length;
    if (metaCount > 0) {
      lines = lines.slice(0, metaCount);
      while (lines.length < metaCount) lines.push("");
    }
    if (!lines.length) lines = [""];

    const commitLines = (nextLines: string[]) => {
      onStoredChange(serializeAddressOfPropertyStored(nextLines));
    };

    return (
      <div className="dvc-address-lines">
        {lines.map((line, index) => (
          <Form.Control
            key={`${field.id}-addr-${index}`}
            type="text"
            className={index < lines.length - 1 ? "mb-2" : undefined}
            value={line}
            disabled={isDisabled}
            onChange={(e) => {
              const next = [...lines];
              next[index] = e.target.value;
              commitLines(next);
            }}
            size="sm"
            placeholder={lines.length > 1 ? `Address line ${index + 1}` : undefined}
          />
        ))}
      </div>
    );
  }

  renderFieldInput(
    field: ChecklistFieldDef,
    valueOverride?: string,
    onChangeOverride?: (v: string) => void,
    radioNameSuffix?: string
  ) {
    const isDisabled = !!field.disabled;
    const v =
      valueOverride !== undefined ? valueOverride : this.state.checklistValues[field.id] ?? "";
    const onChange =
      onChangeOverride ?? ((val: string) => this.setChecklistValue(field.id, val));
    const rn = radioNameSuffix ?? field.id;
    if (field.type === "text" && isAddressOfPropertyMappedField(field)) {
      return this.renderAddressOfPropertyInputs(field, v, onChange, isDisabled);
    }
    if (isChecklistDateField(field)) {
      return (
        <Form.Control
          type="text"
          inputMode="numeric"
          value={checklistDateInputValue(v)}
          placeholder={CHECKLIST_DATE_DISPLAY_FORMAT}
          disabled={isDisabled}
          onChange={(e) => onChange(maskChecklistDateInput(e.target.value))}
          size="sm"
        />
      );
    }
    switch (field.type) {
      case "dropdown": {
        const displayValue = normalizeMappedDropdownValue(
          field,
          v,
          resolveScrutinyFieldTag(field)
        );
        return (
          <SearchableSelect
            value={displayValue}
            onChange={onChange}
            isDisabled={isDisabled}
            options={(field.options || []).map((opt) => ({ value: opt, label: opt }))}
            ariaLabel={field.label}
          />
        );
      }
      case "checkbox":
        return (
          <Form.Check
            type="checkbox"
            checked={v === "true"}
            disabled={isDisabled}
            onChange={(e) => onChange(e.target.checked ? "true" : "false")}
            label="Yes"
          />
        );
      case "yes_no": {
        const yn =
          v === "Yes" || v === "No"
            ? v
            : isChecklistTruthyScalar(v)
              ? "Yes"
              : isChecklistFalsyScalar(v)
                ? "No"
                : v;
        return (
          <div className="d-flex align-items-center flex-wrap" style={{ gap: "0.75rem" }}>
            <Form.Check
              type="radio"
              name={`yn-${rn}`}
              id={`yn-yes-${rn}`}
              label="Yes"
              checked={yn === "Yes"}
              disabled={isDisabled}
              onChange={() => onChange("Yes")}
            />
            <Form.Check
              type="radio"
              name={`yn-${rn}`}
              id={`yn-no-${rn}`}
              label="No"
              checked={yn === "No"}
              disabled={isDisabled}
              onChange={() => onChange("No")}
            />
          </div>
        );
      }
      case "remarks":
        return (
          <Form.Control
            as="textarea"
            rows={2}
            value={v}
            disabled={isDisabled}
            onChange={(e) => onChange(e.target.value)}
            size="sm"
          />
        );
      default:
        return (
          <Form.Control
            type="text"
            value={v}
            disabled={isDisabled}
            onChange={(e) => onChange(e.target.value)}
            size="sm"
          />
        );
    }
  }

  renderNestedFollowUpsRuntime(
    parentFu: DropdownOptionFollowUpDef,
    ctx: FollowUpRuntimeContext
  ): React.ReactNode {
    if (!parentFu.nestedFollowUpsEnabled || !parentFu.nestedFollowUps?.length) return null;
    if (!fieldTypeSupportsOptionFollowUps(parentFu.questionType)) return null;
    const sub = branchKeyForFollowUpAnswer(parentFu, ctx.checklist, ctx.storageKey);
    if (parentFu.questionType === "dropdown" && !sub) return null;
    if (parentFu.questionType === "yes_no" && !sub) return null;
    if (parentFu.questionType === "text" && !sub) return null;
    const n = parentFu.nestedFollowUps.find((x) => x.whenOption === sub);
    if (!n?.questionLabel.trim()) return null;
    const branchLabel = labelForParentFollowBranch(parentFu.questionType, n.whenOption);
    const answerStorageKey = ctx.storageKey(n.valueKey);
    const synthetic: ChecklistFieldDef = {
      id: n.valueKey,
      label: n.questionLabel,
      type: n.questionType,
      order: 0,
      required: !!n.required,
      options:
        n.questionType === "dropdown"
          ? n.followUpOptions?.length
            ? [...n.followUpOptions]
            : ["Option A", "Option B"]
          : undefined,
    };
    const followInput = this.renderFieldInput(
      synthetic,
      ctx.checklist[answerStorageKey] ?? "",
      (val) => ctx.onFollowUpChange(answerStorageKey, val),
      `${ctx.keyPrefix}-nested-${n.valueKey}`
    );
    return (
      <div className="dvc-follow-up-nested mt-2 pl-3 border-left border-primary">
        <div className="dvc-follow-up-option mb-1 small">Then if “{branchLabel}”</div>
        <Form.Group className="mb-0">
          <Form.Label className="small mb-1 font-weight-bold d-block">
            {n.questionLabel}
            {!!n.required && <span className="text-danger"> *</span>}
          </Form.Label>
          {this.renderFieldWithVerify(synthetic, followInput, answerStorageKey)}
          {this.renderNestedFollowUpsRuntime(n, ctx)}
        </Form.Group>
      </div>
    );
  }

  renderConditionalFollowUps(
    field: ChecklistFieldDef,
    opts?: {
      parentValue?: string;
      checklist?: Record<string, string>;
      storageKey?: (valueKey: string) => string;
      onFollowUpChange?: (storageKey: string, val: string) => void;
      keyPrefix?: string;
    }
  ) {
    if (field.disabled) return null;
    if (!fieldHasConfiguredFollowUps(field)) return null;
    if (!fieldTypeSupportsOptionFollowUps(field.type)) return null;
    const optionFollowUps = field.optionFollowUps ?? [];
    const checklist = opts?.checklist ?? this.state.checklistValues;
    const storageKey = opts?.storageKey ?? ((k: string) => k);
    const parentValue = opts?.parentValue ?? checklist[field.id] ?? "";
    const selected = triggerFollowBranchKeyForValue(field, parentValue);
    if (field.type === "dropdown" && !selected) return null;
    const fu = optionFollowUps.find((x) => x.whenOption === selected);
    if (!fu || !String(fu.questionLabel ?? "").trim()) return null;
    const branchLabel = labelForParentFollowBranch(field.type, fu.whenOption);
    const answerStorageKey = storageKey(fu.valueKey);
    const onFollowUpChange =
      opts?.onFollowUpChange ??
      ((key: string, val: string) => this.setChecklistValue(key, val));
    const keyPrefix = opts?.keyPrefix ?? field.id;
    const followCtx: FollowUpRuntimeContext = {
      checklist,
      storageKey,
      onFollowUpChange,
      keyPrefix,
    };
    const synthetic: ChecklistFieldDef = {
      id: fu.valueKey,
      label: fu.questionLabel,
      type: fu.questionType,
      order: 0,
      required: !!fu.required,
      options:
        fu.questionType === "dropdown"
          ? fu.followUpOptions?.length
            ? [...fu.followUpOptions]
            : ["Option A", "Option B"]
          : undefined,
    };
    const followInput = this.renderFieldInput(
      synthetic,
      checklist[answerStorageKey] ?? "",
      (val) => onFollowUpChange(answerStorageKey, val),
      `${keyPrefix}-fu-${fu.valueKey}`
    );
    return (
      <div className="dvc-follow-up-shell mt-2 pt-2 border-top">
        <div className="dvc-follow-up-option mb-1">If “{branchLabel}”</div>
        <Form.Group className="mb-0">
          <Form.Label className="small mb-1 font-weight-bold d-block">
            {fu.questionLabel}
            {!!fu.required && <span className="text-danger"> *</span>}
          </Form.Label>
          {this.renderFieldWithVerify(synthetic, followInput, answerStorageKey)}
          {this.renderNestedFollowUpsRuntime(fu, followCtx)}
        </Form.Group>
      </div>
    );
  }

  renderRuntimeGeneralFieldRow(field: ChecklistFieldDef) {
    const foHint = this.frontOfficeHintForField(field);
    const scrutinyHint = this.scrutinyMappedHintForField(field);
    const tagHint = labelTagHintForField(field);
    const fieldInput = (
      <>
        {this.renderFieldInput(field)}
        {this.renderConditionalFollowUps(field)}
      </>
    );
    return (
      <div key={field.id} className="dvc-general-field-row">
        <label className="dvc-general-label">
          {field.label}
          {field.required && <span className="text-danger"> *</span>}
          {tagHint && (
            <span className="dvc-fo-hint" title={tagHint.title}>
              {tagHint.text}
            </span>
          )}
          {foHint && (
            <span className="dvc-fo-hint" title={foHint.title}>
              {foHint.text}
            </span>
          )}
          {scrutinyHint && (
            <span className="dvc-fo-hint" title={scrutinyHint.title}>
              {scrutinyHint.text}
            </span>
          )}
        </label>
        {this.renderFieldWithVerify(field, fieldInput, field.id)}
      </div>
    );
  }

  renderLegalHeirsFieldTile(
    section: ChecklistSectionDef,
    group: ChecklistRepeatableGroupDef,
    rowIndex: number,
    row: Record<string, string>,
    field: ChecklistFieldDef
  ) {
    const foHint = this.frontOfficeHintForField(field);
    const tagHint = labelTagHintForField(field);
    const count = getLegalHeirInputCount(row, field.id);
    const inputs = Array.from({ length: count }, (_, hi) => {
      const storageKey = legalHeirValueKey(field.id, hi);
      const verifyKey = repeatableRowVerifyKey(section.id, group.id, rowIndex, storageKey);
      const heirInput = this.renderFieldInput(
        field,
        row[storageKey] ?? "",
        (val) => this.setRepeatableCell(section.id, group.id, rowIndex, storageKey, val),
        `${section.id}-${group.id}-${rowIndex}-${storageKey}`
      );
      return (
        <div key={storageKey} className="mb-2">
          <Form.Label className="small mb-1 text-muted d-block">
            {field.label} #{hi + 1}
            {field.required && <span className="text-danger"> *</span>}
          </Form.Label>
          {this.renderFieldWithVerify(field, heirInput, verifyKey)}
        </div>
      );
    });
    return (
      <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-2">
        <div
          className={`dvc-field-tile dvc-form-control py-2${
            field.disabled ? " dvc-field-disabled" : ""
          }`}
        >
          <Form.Group className="mb-0">
            <Form.Label className="small mb-2 font-weight-bold d-block">
              {field.label}
              {tagHint && (
                <span className="dvc-fo-hint" title={tagHint.title}>
                  {tagHint.text}
                </span>
              )}
              {foHint && (
                <span className="dvc-fo-hint" title={foHint.title}>
                  {foHint.text}
                </span>
              )}
            </Form.Label>
            {inputs}
          </Form.Group>
        </div>
      </Col>
    );
  }

  renderDocumentScheduleSetsRuntime(
    section: ChecklistSectionDef,
    group: ChecklistRepeatableGroupDef,
    rowIndex: number,
    row: Record<string, string>,
    scheduleFields: ChecklistFieldDef[]
  ) {
    if (!scheduleFields.length) return null;
    const setCount = getDocumentScheduleSetCount(row, scheduleFields);
    const sets = Array.from({ length: setCount }, (_, setIdx) => (
      <div key={`schedule-set-${setIdx}`} className="dvc-repeat-row mb-2 p-2 border rounded bg-light w-100">
        <div className="mb-2">
          <Badge variant="light" className="border">
            Schedule Set #{setIdx + 1}
          </Badge>
        </div>
        <Row>
          {scheduleFields.map((field) => {
            const storageKey = documentScheduleSetValueKey(field.id, setIdx);
            const foHint = this.frontOfficeHintForField(field);
            const tagHint = labelTagHintForField(field);
            const verifyKey = repeatableRowVerifyKey(section.id, group.id, rowIndex, storageKey);
            const cellInput = (
              <>
                {this.renderFieldInput(
                  field,
                  row[storageKey] ?? "",
                  (val) =>
                    this.setRepeatableCell(section.id, group.id, rowIndex, storageKey, val),
                  `${section.id}-${group.id}-${rowIndex}-${storageKey}`
                )}
                {this.renderConditionalFollowUps(field, {
                  parentValue: row[storageKey] ?? "",
                  checklist: this.state.checklistValues,
                  storageKey: (vk) =>
                    repeatableRowFollowUpStorageKey(section.id, group.id, rowIndex, vk),
                  onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                  keyPrefix: `${section.id}-${group.id}-${rowIndex}-${storageKey}`,
                })}
              </>
            );
            return (
              <Col md={layoutToColMd(field.layout)} key={storageKey} className="mb-2">
                <div
                  className={`dvc-field-tile dvc-form-control py-2${
                    field.disabled ? " dvc-field-disabled" : ""
                  }`}
                >
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-1 font-weight-bold d-block">
                      {field.label}
                      {field.required && <span className="text-danger"> *</span>}
                      {tagHint && (
                        <span className="dvc-fo-hint" title={tagHint.title}>
                          {tagHint.text}
                        </span>
                      )}
                      {foHint && (
                        <span className="dvc-fo-hint" title={foHint.title}>
                          {foHint.text}
                        </span>
                      )}
                    </Form.Label>
                    {this.renderFieldWithVerify(field, cellInput, verifyKey)}
                  </Form.Group>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    ));
    return (
      <Col md={12} key={`${group.id}-schedule-sets-${rowIndex}`} className="mb-2">
        {sets}
      </Col>
    );
  }

  renderRepeatableGroupRuntime(
    section: ChecklistSectionDef,
    g: ChecklistRepeatableGroupDef,
    showHeader = true
  ) {
    const rk = repeatableEntriesKey(section.id, g.id);
    const allRows = this.state.repeatableValues[rk] || [];
    const rowIndices = sortRepeatableRowIndices(allRows);
    return (
      <div key={g.id} className={showHeader ? "mt-2 mb-1" : "mb-1"}>
        {showHeader && (
          <div className="mb-2">
            <span className="small text-muted font-weight-bold text-uppercase">{g.label}</span>
          </div>
        )}
        {rowIndices.map((rowIndex, displayIdx) => {
          const row = allRows[rowIndex];
          return (
          <div key={rowIndex} className="dvc-repeat-row mb-2">
            <div className="mb-2">
              <Badge variant="secondary">Entry #{displayIdx + 1}</Badge>
              {String(row[REPEATABLE_DOC_NO_META_KEY] ?? "").trim() && (
                <span
                  className="dvc-fo-hint ml-2"
                  title="Document number from scrutiny deed row"
                >
                  {`Doc No: ${String(row[REPEATABLE_DOC_NO_META_KEY]).trim()}`}
                </span>
              )}
              {this.props.onPreviewEntryDocument && (
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0 ml-2 align-baseline"
                  title="Preview document"
                  onClick={() =>
                    this.props.onPreviewEntryDocument?.({
                      docNo: String(row[REPEATABLE_DOC_NO_META_KEY] ?? "").trim() || undefined,
                      baseId:
                        String(row[REPEATABLE_DOC_BASE_ID_META_KEY] ?? "").trim() || undefined,
                    })
                  }
                >
                  <i className="fa fa-eye" aria-hidden="true" />
                </button>
              )}
            </div>
            <Row>
              {g.fields.map((field) => {
                if (isLegalHeirsMappedField(field)) {
                  return this.renderLegalHeirsFieldTile(
                    section,
                    g,
                    rowIndex,
                    row,
                    field
                  );
                }
                const foHint = this.frontOfficeHintForField(field);
                const tagHint = labelTagHintForField(field);
                const verifyKey = repeatableRowVerifyKey(section.id, g.id, rowIndex, field.id);
                const cellInput = (
                  <>
                    {this.renderFieldInput(
                      field,
                      row[field.id] ?? "",
                      (val) =>
                        this.setRepeatableCell(section.id, g.id, rowIndex, field.id, val),
                      `${section.id}-${g.id}-${rowIndex}-${field.id}`
                    )}
                    {this.renderConditionalFollowUps(field, {
                      parentValue: row[field.id] ?? "",
                      checklist: this.state.checklistValues,
                      storageKey: (vk) =>
                        repeatableRowFollowUpStorageKey(section.id, g.id, rowIndex, vk),
                      onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                      keyPrefix: `${section.id}-${g.id}-${rowIndex}-${field.id}`,
                    })}
                  </>
                );
                return (
                  <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-2">
                    <div
                      className={`dvc-field-tile dvc-form-control py-2${
                        field.disabled ? " dvc-field-disabled" : ""
                      }`}
                    >
                      <Form.Group className="mb-0">
                        <Form.Label className="small mb-1 font-weight-bold d-block">
                          {field.label}
                          {field.required && <span className="text-danger"> *</span>}
                          {tagHint && (
                            <span className="dvc-fo-hint" title={tagHint.title}>
                              {tagHint.text}
                            </span>
                          )}
                          {foHint && (
                            <span className="dvc-fo-hint" title={foHint.title}>
                              {foHint.text}
                            </span>
                          )}
                        </Form.Label>
                        {this.renderFieldWithVerify(field, cellInput, verifyKey)}
                      </Form.Group>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          );
        })}
      </div>
    );
  }

  missingLodMappedFields(section: ChecklistSectionDef): ChecklistFieldDef[] {
    return mappedFieldsForTagSet(section, MISSING_LOD_TAGS);
  }

  renderAutoRepeatableRuntime(
    section: ChecklistSectionDef,
    fields: ChecklistFieldDef[],
    groupId: string,
    entryLabelPrefix = "Entry"
  ) {
    const rk = repeatableEntriesKey(section.id, groupId);
    const rows = this.state.repeatableValues[rk] || [];
    if (!rows.length) return null;
    return (
      <div className="mb-1">
        {rows.map((row, rowIdx) => (
          <div key={rowIdx} className="dvc-repeat-row mb-2">
            <div className="mb-2">
              <Badge variant="secondary">
                {entryLabelPrefix} #{rowIdx + 1}
              </Badge>
            </div>
            <Row>
              {fields.map((field) => {
                const foHint = this.frontOfficeHintForField(field);
                const tagHint = labelTagHintForField(field);
                const verifyKey = repeatableRowVerifyKey(section.id, groupId, rowIdx, field.id);
                const cellInput = (
                  <>
                    {this.renderFieldInput(
                      field,
                      row[field.id] ?? "",
                      (val) => this.setRepeatableCell(section.id, groupId, rowIdx, field.id, val),
                      `${section.id}-${groupId}-${rowIdx}-${field.id}`
                    )}
                    {this.renderConditionalFollowUps(field, {
                      parentValue: row[field.id] ?? "",
                      checklist: this.state.checklistValues,
                      storageKey: (vk) =>
                        repeatableRowFollowUpStorageKey(section.id, groupId, rowIdx, vk),
                      onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                      keyPrefix: `${section.id}-${groupId}-${rowIdx}-${field.id}`,
                    })}
                  </>
                );
                return (
                  <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-2">
                    <div
                      className={`dvc-field-tile dvc-form-control py-2${
                        field.disabled ? " dvc-field-disabled" : ""
                      }`}
                    >
                      <Form.Group className="mb-0">
                        <Form.Label className="small mb-1 font-weight-bold d-block">
                          {field.label}
                          {field.required && <span className="text-danger"> *</span>}
                          {tagHint && (
                            <span className="dvc-fo-hint" title={tagHint.title}>
                              {tagHint.text}
                            </span>
                          )}
                          {foHint && (
                            <span className="dvc-fo-hint" title={foHint.title}>
                              {foHint.text}
                            </span>
                          )}
                        </Form.Label>
                        {this.renderFieldWithVerify(field, cellInput, verifyKey)}
                      </Form.Group>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ))}
      </div>
    );
  }

  renderHierarchyGroupRowFields(
    section: ChecklistSectionDef,
    group: ChecklistRepeatableGroupDef,
    row: Record<string, string>,
    rowIndex: number,
    badgeLabel: string,
    fallbackSurveyType?: string | null,
    surveyTypeExtraSources: SurveyTypeFieldSource[] = [],
    gdSurveySource?: Record<string, string> | null
  ) {
    if (!group.fields.length) return null;
    const visibilityRow = mergeSurveyTypeVisibilityRow(row, gdSurveySource);
    const surveyType = resolveSurveyTypeFromHierarchyRow(
      group.fields,
      visibilityRow,
      fallbackSurveyType,
      (id) => row[id] ?? "",
      surveyTypeExtraSources
    );
    const parseCustomMeasurementEntries = (r: Record<string, string>) => {
      const labelsRaw = String(r[MEAS_DIR_CUSTOM_LABELS_JSON_KEY] ?? "").trim();
      const valuesRaw = String(r[MEAS_DIR_CUSTOM_VALUES_JSON_KEY] ?? "").trim();
      let labels: string[] = [];
      let values: string[] = [];
      if (labelsRaw.startsWith("[")) {
        try {
          const parsed = JSON.parse(labelsRaw);
          if (Array.isArray(parsed)) labels = parsed.map((v) => String(v ?? "").trim());
        } catch {}
      }
      if (valuesRaw.startsWith("[")) {
        try {
          const parsed = JSON.parse(valuesRaw);
          if (Array.isArray(parsed)) values = parsed.map((v) => String(v ?? "").trim());
        } catch {}
      }
      const total = Math.max(labels.length, values.length);
      return Array.from({ length: total }, (_, i) => ({
        label: labels[i] || "Custom",
        value: values[i] || "",
      })).filter((e) => e.label || e.value);
    };
    const displayFieldLabel = (field: ChecklistFieldDef) =>
      String(
        row[`${MEAS_DIR_CUSTOM_LABEL_BY_FIELD_PREFIX}${field.id}`] ?? field.label ?? ""
      ).trim() || field.label;
    return (
      <div className="mb-3">
        <Badge variant="secondary" className="mb-2">
          {badgeLabel}
        </Badge>
        <Row>
          {group.fields.map((field) => {
            if (!isSurveyFieldVisibleForSurveyType(field, surveyType, visibilityRow)) return null;
            if (String(field.label ?? "").trim().toLowerCase() === "custom") {
              const customEntries = parseCustomMeasurementEntries(row);
              if (customEntries.length > 1) {
                const persistCustomValues = (labels: string[], values: string[]) => {
                  const rk = repeatableEntriesKey(section.id, group.id);
                  const rows = [...(this.state.repeatableValues[rk] || [])];
                  const nextRow = { ...(rows[rowIndex] || {}) };
                  nextRow[MEAS_DIR_CUSTOM_LABELS_JSON_KEY] = JSON.stringify(labels);
                  nextRow[MEAS_DIR_CUSTOM_VALUES_JSON_KEY] = JSON.stringify(values);
                  nextRow[MEAS_DIR_CUSTOM_LABELS_KEY] = labels.filter((l) => l.trim()).join(", ");
                  nextRow[MEAS_DIR_CUSTOM_VALUES_KEY] = values.filter((v) => v.trim()).join(", ");
                  if (labels[0]) {
                    nextRow[`${MEAS_DIR_CUSTOM_LABEL_BY_FIELD_PREFIX}${field.id}`] = labels[0];
                    nextRow.measure_custom = labels.filter((l) => l.trim()).join(", ");
                  }
                  if (values[0]) nextRow[field.id] = values[0];
                  rows[rowIndex] = nextRow;
                  this.setState(
                    { repeatableValues: { ...this.state.repeatableValues, [rk]: rows } },
                    () => this.emitChange()
                  );
                };
                return customEntries.map((entry, idx) => {
                  const foHint = this.frontOfficeHintForField(field);
                  const tagHint = labelTagHintForField(field);
                  const verifyKey =
                    idx === 0
                      ? repeatableRowVerifyKey(section.id, group.id, rowIndex, field.id)
                      : undefined;
                  const cellInput = this.renderFieldInput(
                    field,
                    entry.value,
                    (val) => {
                      const labels = customEntries.map((e) => e.label);
                      const values = customEntries.map((e, i) => (i === idx ? val : e.value));
                      persistCustomValues(labels, values);
                    },
                    `${section.id}-${group.id}-${rowIndex}-${field.id}-custom-${idx}`
                  );
                  return (
                    <Col md={layoutToColMd(field.layout)} key={`${field.id}-custom-${idx}`} className="mb-2">
                      <div
                        className={`dvc-field-tile dvc-form-control py-2${
                          field.disabled ? " dvc-field-disabled" : ""
                        }`}
                      >
                        <Form.Group className="mb-0">
                          <Form.Label className="small mb-1 font-weight-bold d-block">
                            {entry.label}
                            {field.required && idx === 0 && <span className="text-danger"> *</span>}
                            {tagHint && (
                              <span className="dvc-fo-hint" title={tagHint.title}>
                                {tagHint.text}
                              </span>
                            )}
                            {foHint && (
                              <span className="dvc-fo-hint" title={foHint.title}>
                                {foHint.text}
                              </span>
                            )}
                          </Form.Label>
                          {idx === 0 && verifyKey
                            ? this.renderFieldWithVerify(field, cellInput, verifyKey)
                            : cellInput}
                        </Form.Group>
                      </div>
                    </Col>
                  );
                });
              }
            }
            const foHint = this.frontOfficeHintForField(field);
            const tagHint = labelTagHintForField(field);
            const verifyKey = repeatableRowVerifyKey(section.id, group.id, rowIndex, field.id);
            const cellInput = (
              <>
                {this.renderFieldInput(
                  field,
                  row[field.id] ?? "",
                  (val) => this.setRepeatableCell(section.id, group.id, rowIndex, field.id, val),
                  `${section.id}-${group.id}-${rowIndex}-${field.id}`
                )}
                {this.renderConditionalFollowUps(field, {
                  parentValue: row[field.id] ?? "",
                  checklist: this.state.checklistValues,
                  storageKey: (vk) =>
                    repeatableRowFollowUpStorageKey(section.id, group.id, rowIndex, vk),
                  onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                  keyPrefix: `${section.id}-${group.id}-${rowIndex}-${field.id}`,
                })}
              </>
            );
            return (
              <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-2">
                <div
                  className={`dvc-field-tile dvc-form-control py-2${
                    field.disabled ? " dvc-field-disabled" : ""
                  }`}
                >
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-1 font-weight-bold d-block">
                      {displayFieldLabel(field)}
                      {field.required && <span className="text-danger"> *</span>}
                      {tagHint && (
                        <span className="dvc-fo-hint" title={tagHint.title}>
                          {tagHint.text}
                        </span>
                      )}
                      {foHint && (
                        <span className="dvc-fo-hint" title={foHint.title}>
                          {foHint.text}
                        </span>
                      )}
                    </Form.Label>
                    {this.renderFieldWithVerify(field, cellInput, verifyKey)}
                  </Form.Group>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }

  renderSurveyNatureFieldsForSchedule(
    section: ChecklistSectionDef,
    natureRaw: string | undefined | null,
    opts?: {
      fdId?: string;
      scheduleId?: string;
      useScopedKeys?: boolean;
    }
  ) {
    const natureKey = matchNaturePropertyKey(natureRaw ?? "");
    const visibleSurveyGroups = surveyGroupsVisibleForFile(section, natureKey).filter(
      (g) => g.fields.length > 0
    );
    if (!visibleSurveyGroups.length) return null;
    const useScoped =
      !!opts?.useScopedKeys &&
      String(opts?.fdId ?? "").trim() !== "" &&
      String(opts?.scheduleId ?? "").trim() !== "";
    return (
      <>
        {visibleSurveyGroups.map((group) => (
          <div key={group.id} className="dvc-survey-nature-card mb-3 p-3 border rounded bg-light">
            <div className="dvc-deed-type-head mb-2 d-flex flex-wrap align-items-center">
              <span className="dvc-deed-type-title">{group.label}</span>
              {opts?.fdId ? this.renderSurveyDocNoBadge(String(opts.fdId)) : null}
            </div>
            {group.fields.length > 0 ? (
              <Row>
                {(() => {
                  const readScoped = (fieldId: string) => {
                    const key = useScoped
                      ? surveyNatureFieldScopeKey(opts!.fdId!, opts!.scheduleId!, fieldId)
                      : fieldId;
                    return this.state.checklistValues[key] ?? "";
                  };
                  const surveyType = resolveSurveyTypeFromHierarchyRow(
                    group.fields,
                    {},
                    null,
                    readScoped
                  );
                  const surveyVisibilityRow = mergeSurveyTypeVisibilityRow(
                    {},
                    surveyTypeVisibilityRowFromDocument(
                      mergedGeneralDetailsByDocument(
                        this.state.generalDetailsByDocument,
                        this.scrutinyApiCache
                      ),
                      opts?.fdId,
                      opts?.scheduleId
                    )
                  );
                  return group.fields.map((field) => {
                    if (!isSurveyFieldVisibleForSurveyType(field, surveyType, surveyVisibilityRow)) {
                      return null;
                    }
                  const fieldKey = useScoped
                    ? surveyNatureFieldScopeKey(opts!.fdId!, opts!.scheduleId!, field.id)
                    : field.id;
                  const foHint = this.frontOfficeHintForField(field);
                  const tagHint = labelTagHintForField(field);
                  const followStorageKey = useScoped
                    ? (vk: string) =>
                        surveyNatureFieldScopeKey(opts!.fdId!, opts!.scheduleId!, vk)
                    : (vk: string) => vk;
                  const fieldInput = (
                    <>
                      {this.renderFieldInput(
                        field,
                        this.state.checklistValues[fieldKey] ?? "",
                        (val) => this.setChecklistValue(fieldKey, val),
                        fieldKey
                      )}
                      {this.renderConditionalFollowUps(field, {
                        parentValue: this.state.checklistValues[fieldKey] ?? "",
                        checklist: this.state.checklistValues,
                        storageKey: followStorageKey,
                        onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                        keyPrefix: fieldKey,
                      })}
                    </>
                  );
                  return (
                    <Col md={layoutToColMd(field.layout)} key={fieldKey} className="mb-3">
                      <div
                        className={`dvc-field-tile dvc-form-control${
                          field.disabled ? " dvc-field-disabled" : ""
                        }`}
                      >
                        <Form.Group className="mb-0">
                          <Form.Label className="small mb-2 font-weight-bold d-block">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                            {tagHint && (
                              <span className="dvc-fo-hint" title={tagHint.title}>
                                {tagHint.text}
                              </span>
                            )}
                            {foHint && (
                              <span className="dvc-fo-hint" title={foHint.title}>
                                {foHint.text}
                              </span>
                            )}
                          </Form.Label>
                          {this.renderFieldWithVerify(field, fieldInput, fieldKey)}
                        </Form.Group>
                      </div>
                    </Col>
                  );
                });
                })()}
              </Row>
            ) : null}
          </div>
        ))}
      </>
    );
  }

  renderSurveyDocNoBadge(fdId: string) {
    const meta = resolveSurveyDocumentMeta(this.scrutinyApiCache, fdId);
    const docNo = String(meta?.docNo ?? "").trim();
    if (!docNo) return null;
    return (
      <span className="ml-2 d-inline-flex align-items-center flex-wrap">
        <Badge variant="info" className="font-weight-normal">
          {`Doc No: ${docNo}`}
        </Badge>
        {this.props.onPreviewEntryDocument && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0 ml-2 align-baseline"
            title="Preview document"
            onClick={() =>
              this.props.onPreviewEntryDocument?.({
                docNo,
                baseId: fdId,
              })
            }
          >
            <i className="fa fa-eye" aria-hidden="true" />
          </button>
        )}
      </span>
    );
  }

  renderSurveyMeasurementHierarchyBlock(
    section: ChecklistSectionDef,
    fdId: string,
    measurementGroup: ChecklistRepeatableGroupDef | undefined,
    boundaryMeta: Record<string, string>,
    meas: { measurement_id?: string | number },
    measIdx: number
  ) {
    if (!surveyHierarchyGroupHasChecklistFields(measurementGroup)) return null;
    const measId = String(meas.measurement_id ?? "");
    const measurementMeta = {
      ...boundaryMeta,
      [SURVEY_HIERARCHY_META.MEASUREMENT_ID]: measId,
    };
    const measurementRows = hierarchyRowsForDocument(
      section.id,
      measurementGroup!.id,
      fdId,
      this.state.repeatableValues,
      measurementMeta
    );

    return (
      <div
        key={`meas-${measId || measIdx}`}
        className="dvc-survey-nested-card mb-2 p-2 border rounded ml-2"
      >
        <div className="font-weight-bold mb-2">Measurement {measIdx + 1}</div>
        {measurementRows.map(({ row, rowIndex }) =>
          this.renderHierarchyGroupRowFields(
            section,
            measurementGroup!,
            row,
            rowIndex,
            `${measurementGroup!.label} #${measIdx + 1}`
          )
        )}
      </div>
    );
  }

  renderSurveyBoundaryHierarchyBlock(
    section: ChecklistSectionDef,
    fdId: string,
    boundaryGroup: ChecklistRepeatableGroupDef | undefined,
    measurementGroup: ChecklistRepeatableGroupDef | undefined,
    surveyMeta: Record<string, string>,
    bnd: { measu_id?: string | number; measurement_list?: { measurement_id?: string | number }[] },
    bndIdx: number
  ) {
    const boundaryHasFields = surveyHierarchyGroupHasChecklistFields(boundaryGroup);
    const measurementHasFields = surveyHierarchyGroupHasChecklistFields(measurementGroup);
    const measurementBlocks = measurementHasFields
      ? (bnd.measurement_list || [])
          .map((meas, measIdx) =>
            this.renderSurveyMeasurementHierarchyBlock(
              section,
              fdId,
              measurementGroup,
              {
                ...surveyMeta,
                [SURVEY_HIERARCHY_META.BOUNDARY_ID]: String(bnd.measu_id ?? ""),
              },
              meas,
              measIdx
            )
          )
          .filter(Boolean)
      : [];
    if (!boundaryHasFields && !measurementBlocks.length) return null;

    const bndId = String(bnd.measu_id ?? "");
    const boundaryMeta = {
      ...surveyMeta,
      [SURVEY_HIERARCHY_META.BOUNDARY_ID]: bndId,
    };
    const boundaryRows = boundaryHasFields
      ? hierarchyRowsForDocument(
          section.id,
          boundaryGroup!.id,
          fdId,
          this.state.repeatableValues,
          boundaryMeta
        )
      : [];

    return (
      <div
        key={`bnd-${bndId || bndIdx}`}
        className="dvc-survey-nested-card mb-3 p-3 border rounded ml-2 bg-light"
      >
        <div className="font-weight-bold mb-2">Boundary {bndIdx + 1}</div>
        {boundaryHasFields &&
          boundaryRows.map(({ row, rowIndex }) =>
            this.renderHierarchyGroupRowFields(
              section,
              boundaryGroup!,
              row,
              rowIndex,
              `${boundaryGroup!.label} #${bndIdx + 1}`
            )
          )}
        {measurementBlocks}
      </div>
    );
  }

  renderSurveyDetailHierarchyBlock(
    section: ChecklistSectionDef,
    fdId: string,
    surveyGroup: ChecklistRepeatableGroupDef | undefined,
    boundaryGroup: ChecklistRepeatableGroupDef | undefined,
    measurementGroup: ChecklistRepeatableGroupDef | undefined,
    scheduleMeta: Record<string, string>,
    sur: {
      sur_id?: string | number;
      survey_type?: string;
      ts_old_survey_no?: boolean | string;
      ts_old_ts_no?: boolean | string;
      old_ts_s_no?: string;
      old_ts_survey_no?: string;
      old_ts_no?: string;
      boundary_details?: {
        measu_id?: string | number;
        measurement_list?: { measurement_id?: string | number }[];
      }[];
    },
    surIdx: number,
    natureKey: string,
    scheduleGroup?: ChecklistRepeatableGroupDef,
    gdByDoc?: Record<string, GeneralDetailsDocumentHierarchy>
  ) {
    const surveyHasFields = surveyHierarchyGroupHasChecklistFields(surveyGroup);
    const boundaryBlocks = (sur.boundary_details || [])
      .map((bnd, bndIdx) =>
        this.renderSurveyBoundaryHierarchyBlock(
          section,
          fdId,
          boundaryGroup,
          measurementGroup,
          {
            ...scheduleMeta,
            [SURVEY_HIERARCHY_META.SUR_ID]: String(sur.sur_id ?? ""),
          },
          bnd,
          bndIdx
        )
      )
      .filter(Boolean);
    if (!surveyHasFields && !boundaryBlocks.length) return null;

    const surId = String(sur.sur_id ?? "");
    const surveyMeta = {
      ...scheduleMeta,
      [SURVEY_HIERARCHY_META.SUR_ID]: surId,
    };
    const surveyRows = surveyHasFields
      ? hierarchyRowsForDocument(
          section.id,
          surveyGroup!.id,
          fdId,
          this.state.repeatableValues,
          surveyMeta
        )
      : [];
    const scheduleRows =
      scheduleGroup && surveyHierarchyGroupHasChecklistFields(scheduleGroup)
        ? hierarchyRowsForDocument(
            section.id,
            scheduleGroup.id,
            fdId,
            this.state.repeatableValues,
            scheduleMeta
          )
        : [];
    const scheduleRow = scheduleRows[0]?.row ?? {};
    const surveyTypeExtraSources: SurveyTypeFieldSource[] =
      scheduleGroup && scheduleGroup.fields.length
        ? [
            {
              fields: scheduleGroup.fields,
              readValue: (fieldId) => scheduleRow[fieldId] ?? "",
            },
          ]
        : [];
    const scheduleId = scheduleMeta[SURVEY_HIERARCHY_META.SCHEDULE_ID] ?? "";
    const gdSurveySource = resolveGdSurveyVisibilityRow(
      gdByDoc ?? {},
      fdId,
      scheduleId,
      sur
    );

    return (
      <div
        key={`sur-${surId || surIdx}`}
        className="dvc-survey-nested-card mb-3 p-3 border rounded ml-2"
      >
        <div className="font-weight-bold mb-2">Survey {surIdx + 1}</div>
        {surveyHasFields &&
          surveyRows.map(({ row, rowIndex }) =>
            this.renderHierarchyGroupRowFields(
              section,
              surveyGroup!,
              row,
              rowIndex,
              `${surveyGroup!.label} #${surIdx + 1}`,
              sur.survey_type,
              surveyTypeExtraSources,
              gdSurveySource
            )
          )}
        {boundaryBlocks}
      </div>
    );
  }

  renderSurveyScheduleHierarchyBlock(
    section: ChecklistSectionDef,
    fdId: string,
    sched: GeneralDetailsScheduleRow,
    schedIdx: number,
    natureKey: string,
    gdByDoc?: Record<string, GeneralDetailsDocumentHierarchy>
  ) {
    const scheduleGroup = surveyHierarchyGroupForLevel(section, "schedule", natureKey);
    const surveyGroup = surveyHierarchyGroupForLevel(section, "survey", natureKey);
    const boundaryGroup = surveyHierarchyGroupForLevel(section, "boundary", natureKey);
    const measurementGroup = surveyHierarchyGroupForLevel(section, "measurement", natureKey);
    // Respect Dynamic Checklist Management hierarchy toggles:
    // if "Schedule" level is removed for this nature, do not render GD schedule cards.
    if (!scheduleGroup) return null;
    const scheduleHasFields = surveyHierarchyGroupHasChecklistFields(scheduleGroup);
    const scheduleId = String(sched.id ?? "");
    const scheduleMeta = { [SURVEY_HIERARCHY_META.SCHEDULE_ID]: scheduleId };
    const scheduleRows = scheduleHasFields
      ? hierarchyRowsForDocument(
          section.id,
          scheduleGroup!.id,
          fdId,
          this.state.repeatableValues,
          scheduleMeta
        )
      : [];
    const surveyBlocks = (sched.survey_details || [])
      .map((sur, surIdx) =>
        this.renderSurveyDetailHierarchyBlock(
          section,
          fdId,
          surveyGroup,
          boundaryGroup,
          measurementGroup,
          scheduleMeta,
          sur,
          surIdx,
          natureKey,
          scheduleGroup,
          gdByDoc
        )
      )
      .filter(Boolean);
    // If no checklist fields are configured under Schedule in management,
    // do not render legacy nature-scoped schedule fields in runtime.
    const natureFields = scheduleHasFields
      ? this.renderSurveyNatureFieldsForSchedule(section, sched.nature_doc, {
          fdId,
          scheduleId,
          useScopedKeys: true,
        })
      : null;
    if (!scheduleHasFields && !surveyBlocks.length && !natureFields) return null;

    return (
      <div
        key={`sched-${fdId}-${scheduleId || schedIdx}`}
        className="dvc-survey-schedule-card mb-3 p-3 border rounded bg-white"
      >
        <div className="dvc-deed-type-head mb-3">
          <span className="dvc-deed-type-title">
            Schedule {scheduleDisplayNumber(sched, schedIdx)}
          </span>
        </div>

        {scheduleHasFields &&
          scheduleRows.map(({ row, rowIndex }) =>
            this.renderHierarchyGroupRowFields(
              section,
              scheduleGroup!,
              row,
              rowIndex,
              `${scheduleGroup!.label} #${schedIdx + 1}`,
              sched.survey_details?.[0]?.survey_type,
              [],
              resolveGdSurveyVisibilityRow(gdByDoc ?? {}, fdId, scheduleId, sched.survey_details?.[0])
            )
          )}

        {natureFields}
        {surveyBlocks}
      </div>
    );
  }

  renderEcGroupField(
    section: ChecklistSectionDef,
    group: ChecklistRepeatableGroupDef,
    rowIndex: number,
    field: ChecklistFieldDef
  ) {
    const rk = repeatableEntriesKey(section.id, group.id);
    const row = (this.state.repeatableValues[rk] || [])[rowIndex] || {};
    const verifyKey = `${rk}::${rowIndex}::${field.id}`;
    const foHint = this.frontOfficeHintForField(field);
    const tagHint = labelTagHintForField(field);
    const fieldInput = (
      <>
        {this.renderFieldInput(
          field,
          row[field.id] ?? "",
          (val) => this.setRepeatableCell(section.id, group.id, rowIndex, field.id, val),
          `${section.id}-${group.id}-${rowIndex}-${field.id}`
        )}
        {this.renderConditionalFollowUps(field, {
          parentValue: row[field.id] ?? "",
          checklist: this.state.checklistValues,
          storageKey: (vk) =>
            repeatableRowFollowUpStorageKey(section.id, group.id, rowIndex, vk),
          onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
          keyPrefix: `${section.id}-${group.id}-${rowIndex}-${field.id}`,
        })}
      </>
    );
    return (
      <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-3">
        <div
          className={`dvc-field-tile dvc-form-control${field.disabled ? " dvc-field-disabled" : ""}`}
        >
          <Form.Group className="mb-0">
            <Form.Label className="small mb-2 font-weight-bold d-block">
              {field.label}
              {field.required && <span className="text-danger"> *</span>}
              {tagHint && (
                <span className="dvc-fo-hint" title={tagHint.title}>
                  {tagHint.text}
                </span>
              )}
              {foHint && (
                <span className="dvc-fo-hint" title={foHint.title}>
                  {foHint.text}
                </span>
              )}
            </Form.Label>
            {this.renderFieldWithVerify(field, fieldInput, verifyKey)}
          </Form.Group>
        </div>
      </Col>
    );
  }

  renderEcEntryList(
    section: ChecklistSectionDef,
    blockId: string,
    entryGroup: ChecklistRepeatableGroupDef
  ) {
    const entryKey = repeatableEntriesKey(section.id, entryGroup.id);
    const allRows = this.state.repeatableValues[entryKey] || [];
    const relatedEntries = relatedEntryRowsForBlock(
      section.id,
      this.state.repeatableValues,
      blockId
    ).sort(
      (a, b) =>
        parseInt(String(a[EC_HIERARCHY_META.LINE_INDEX] ?? "0"), 10) -
        parseInt(String(b[EC_HIERARCHY_META.LINE_INDEX] ?? "0"), 10)
    );

    if (!relatedEntries.length) {
      return (
        <p className="small text-muted mb-0 mt-3">
          No related EC entries for this document.
        </p>
      );
    }

    return (
      <div className="dvc-ec-entry-details mt-4">
        <div className="dvc-deed-type-head mb-3">
          <span className="dvc-deed-type-title">Related entries</span>
        </div>
        {relatedEntries.map((row) => {
          const lineIndex = parseInt(String(row[EC_HIERARCHY_META.LINE_INDEX] ?? "0"), 10);
          const rowIndex = allRows.indexOf(row);
          if (rowIndex < 0) return null;
          return (
            <div key={`${blockId}-${lineIndex}`} className="dvc-ec-entry-detail-card">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Badge variant="secondary">Entry {lineIndex}</Badge>
                <Form.Check type="checkbox" label="Related" checked disabled />
              </div>
              <Row>
                {entryGroup.fields.map((field) =>
                  this.renderEcGroupField(section, entryGroup, rowIndex, field)
                )}
              </Row>
            </div>
          );
        })}
      </div>
    );
  }

  renderEcVerificationRuntime(section: ChecklistSectionDef) {
    const blockGroup = ecBlockGroup(section);
    const entryGroup = ecEntryGroup(section);
    const ecGroupFieldIds = new Set(
      (section.repeatableGroups || [])
        .filter((g) => g.ecHierarchyLevel != null)
        .flatMap((g) => g.fields.map((f) => f.id))
    );
    const summaryFields = section.fields.filter((f) => !ecGroupFieldIds.has(f.id));
    const blockKey = blockGroup ? repeatableEntriesKey(section.id, blockGroup.id) : "";
    let blockRows = blockKey ? this.state.repeatableValues[blockKey] || [] : [];

    if (!blockRows.length && this.scrutinyApiCache) {
      const apiBlocks = ecBlocksFromScrutiny(this.scrutinyApiCache);
      if (apiBlocks.length && blockGroup) {
        blockRows = [{} as Record<string, string>];
      }
    }

    return (
      <>
        {summaryFields.length > 0 && (
          <Row className="mb-3">
            {summaryFields.map((field) => (
              <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-3">
                {this.renderRuntimeGeneralFieldRow(field)}
              </Col>
            ))}
          </Row>
        )}
        {!blockGroup ? (
          <p className="small text-muted mb-0">
            Configure EC document details and entry details in Dynamic Checklist Management.
          </p>
        ) : blockRows.length === 0 ? (
          <p className="small text-muted mb-0">
            No EC documents found for this file. Add EC data in scrutiny first.
          </p>
        ) : (
          blockRows.map((blockRow, blockRowIndex) => {
            const blockId =
              String(blockRow[EC_HIERARCHY_META.BLOCK_ID] ?? "").trim() ||
              `manual-${blockRowIndex}`;
            return (
              <div
                key={`${blockId}-${blockRowIndex}`}
                className="dvc-ec-flow-card mb-4 p-3 border rounded bg-white"
              >
                <div className="dvc-deed-type-head mb-3">
                  <span className="dvc-deed-type-title">
                    {ecBlockDisplayLabel(blockRow, blockGroup, blockRowIndex)}
                  </span>
                </div>
                {blockGroup.fields.length > 0 ? (
                  <Row>
                    {blockGroup.fields.map((field) =>
                      this.renderEcGroupField(section, blockGroup, blockRowIndex, field)
                    )}
                  </Row>
                ) : (
                  <p className="small text-muted mb-3">No EC document fields configured.</p>
                )}
                {entryGroup &&
                  entryGroup.fields.length > 0 &&
                  this.renderEcEntryList(section, blockId, entryGroup)}
              </div>
            );
          })
        )}
      </>
    );
  }

  renderSurveyVerificationRuntime(section: ChecklistSectionDef) {
    const gdByDoc: Record<string, GeneralDetailsDocumentHierarchy> = {
      ...(this.scrutinyApiCache?.generalDetailsByDocument &&
      typeof this.scrutinyApiCache.generalDetailsByDocument === "object"
        ? (this.scrutinyApiCache.generalDetailsByDocument as Record<
            string,
            GeneralDetailsDocumentHierarchy
          >)
        : {}),
      ...this.state.generalDetailsByDocument,
    };
    // Survey verification is file-level: include every document that has GD schedules
    // (e.g. Existing building on one deed + Vacant land on another).
    const fdIdsWithSchedules = listSurveyDocumentFdIdsWithSchedules(gdByDoc);
    const fdId =
      fdIdsWithSchedules[0] ||
      resolveSurveyDocumentFdWithSchedules(this.props.activeDocumentFdId, {
        ...this.scrutinyApiCache,
        generalDetailsByDocument: gdByDoc,
      });
    const natureKeys = resolveSurveyNaturePropertyKeys(
      this.state.frontOfficePrefill,
      this.state.propertyDetailsPrefill,
      gdByDoc,
      null
    );
    const hasHierarchyConfig = surveySectionUsesHierarchy(section);

    if (hasHierarchyConfig) {
      if (!fdIdsWithSchedules.length) {
        return (
          <p className="small text-muted mb-0">
            No General Detail schedules found for this file. Add schedules in General Detail first.
          </p>
        );
      }

      type ScheduleItem = {
        fdId: string;
        sched: GeneralDetailsScheduleRow;
        schedIdx: number;
      };
      const schedulesByNature = new Map<string, ScheduleItem[]>();
      fdIdsWithSchedules.forEach((docFdId) => {
        const schedules = Array.isArray(gdByDoc[docFdId]?.schedules)
          ? gdByDoc[docFdId].schedules!
          : [];
        schedules.forEach((sched, schedIdx) => {
          const natureKey = matchNaturePropertyKey(sched.nature_doc ?? "") ?? "__unmatched__";
          if (!schedulesByNature.has(natureKey)) schedulesByNature.set(natureKey, []);
          schedulesByNature.get(natureKey)!.push({ fdId: docFdId, sched, schedIdx });
        });
      });

      const natureBlocks = Array.from(schedulesByNature.entries())
        .map(([natureKey, items]) => {
          const natureTitle =
            natureKey === "__unmatched__"
              ? "Other schedules"
              : naturePropertyLabel(natureKey) || natureKey;
          const resolvedNatureKey = natureKey === "__unmatched__" ? "" : natureKey;
          const scheduleBlocks = items
            .map(({ fdId: itemFdId, sched, schedIdx }) =>
              this.renderSurveyScheduleHierarchyBlock(
                section,
                itemFdId,
                sched,
                schedIdx,
                resolvedNatureKey,
                gdByDoc
              )
            )
            .filter(Boolean);
          if (!scheduleBlocks.length) return null;
          const uniqueFdIds = Array.from(new Set(items.map((i) => i.fdId)));
          return (
            <div key={natureKey} className="dvc-survey-nature-flow mb-4">
              <div className="dvc-deed-type-head mb-3">
                <div className="d-flex flex-wrap align-items-center mb-1">
                  <span className="dvc-deed-type-title">{natureTitle}</span>
                  {uniqueFdIds.map((docFd) => (
                    <React.Fragment key={docFd}>{this.renderSurveyDocNoBadge(docFd)}</React.Fragment>
                  ))}
                </div>
                <span className="small text-muted d-block">
                  Nature of property → Schedule → Survey → Boundary → Measurement
                </span>
              </div>
              {scheduleBlocks}
            </div>
          );
        })
        .filter(Boolean);

      if (!natureBlocks.length) {
        return (
          <p className="small text-muted mb-0">
            No General Detail schedules match the configured Survey Verification natures. Add
            natures in Dynamic Checklist Management or schedules in General Detail.
          </p>
        );
      }

      return <>{natureBlocks}</>;
    }

    const visibleSurveyGroups = resolveVisibleSurveyNatureGroups(section, natureKeys).filter(
      (group) => group.fields.length > 0
    );
    if (!visibleSurveyGroups.length) {
      return (
        <p className="small text-muted mb-0">
          No nature-of-property checklist matches this file. Set nature in General Detail (Schedule)
          or Front Office.
        </p>
      );
    }
    return (
      <>
        {visibleSurveyGroups.map((group) => (
          <div key={group.id} className="dvc-survey-nature-card mb-4 p-3 border rounded bg-white">
            <div className="dvc-deed-type-head mb-3 d-flex flex-wrap align-items-center">
              <span className="dvc-deed-type-title">{group.label}</span>
              {fdIdsWithSchedules.map((docFd) => (
                <React.Fragment key={docFd}>{this.renderSurveyDocNoBadge(docFd)}</React.Fragment>
              ))}
            </div>
            {group.fields.length > 0 ? (
              <Row>
                {(() => {
                  const surveyType = resolveSurveyTypeFromHierarchyRow(
                    group.fields,
                    {},
                    null,
                    (fieldId) => this.state.checklistValues[fieldId] ?? ""
                  );
                  const surveyVisibilityRow = mergeSurveyTypeVisibilityRow(
                    {},
                    surveyTypeVisibilityRowFromDocument(gdByDoc, fdId)
                  );
                  return group.fields.map((field) => {
                    if (!isSurveyFieldVisibleForSurveyType(field, surveyType, surveyVisibilityRow)) {
                      return null;
                    }
                  const foHint = this.frontOfficeHintForField(field);
                  const tagHint = labelTagHintForField(field);
                  const fieldInput = (
                    <>
                      {this.renderFieldInput(field)}
                      {this.renderConditionalFollowUps(field)}
                    </>
                  );
                  return (
                    <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-3">
                      <div
                        className={`dvc-field-tile dvc-form-control${
                          field.disabled ? " dvc-field-disabled" : ""
                        }`}
                      >
                        <Form.Group className="mb-0">
                          <Form.Label className="small mb-2 font-weight-bold d-block">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                            {tagHint && (
                              <span className="dvc-fo-hint" title={tagHint.title}>
                                {tagHint.text}
                              </span>
                            )}
                            {foHint && (
                              <span className="dvc-fo-hint" title={foHint.title}>
                                {foHint.text}
                              </span>
                            )}
                          </Form.Label>
                          {this.renderFieldWithVerify(field, fieldInput, field.id)}
                        </Form.Group>
                      </div>
                    </Col>
                  );
                });
                })()}
              </Row>
            ) : (
              <p className="small text-muted mb-0">No checklist fields configured.</p>
            )}
          </div>
        ))}
      </>
    );
  }

  renderDeedDocumentEntryRuntime(section: ChecklistSectionDef, entry: DeedDocumentEntryInOrder) {
    const { gate, group, row, rowIndex, displayIndex } = entry;
    const gateOpen = (this.state.checklistValues[gate.id] ?? "No") === "Yes";
    const showFields = deedDocumentEntryVisible(entry, this.state.checklistValues);
    return (
      <div
        key={`${group.id}-${rowIndex}-${displayIndex}`}
        className="dvc-deed-type-block mb-4 pb-3 border-bottom"
      >
        <div className="dvc-deed-type-head d-flex flex-wrap align-items-center">
          <span className="dvc-deed-type-title">{gate.label}</span>
          {this.renderFieldInput(gate)}
        </div>
        {showFields && (
          <>
            <div className="mb-2">
              <Badge variant="secondary">Document #{displayIndex + 1}</Badge>
              {String(row[REPEATABLE_DOC_NO_META_KEY] ?? "").trim() && (
                <span
                  className="dvc-fo-hint ml-2"
                  title="Document number from scrutiny deed row"
                >
                  {`Doc No: ${String(row[REPEATABLE_DOC_NO_META_KEY]).trim()}`}
                </span>
              )}
              {this.props.onPreviewEntryDocument && (
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0 ml-2 align-baseline"
                  title="Preview document"
                  onClick={() =>
                    this.props.onPreviewEntryDocument?.({
                      docNo: String(row[REPEATABLE_DOC_NO_META_KEY] ?? "").trim() || undefined,
                      baseId:
                        String(row[REPEATABLE_DOC_BASE_ID_META_KEY] ?? "").trim() || undefined,
                    })
                  }
                >
                  <i className="fa fa-eye" aria-hidden="true" />
                </button>
              )}
            </div>
            {(gateOpen || showFields) && (
              <Row>
                {(() => {
                  const scheduleFields = documentScheduleFieldsInGroup(group.fields);
                  const plainFields = group.fields.filter(
                    (field) => !isDocumentScheduleMappedField(field)
                  );
                  return (
                    <>
                      {scheduleFields.length > 0 &&
                        this.renderDocumentScheduleSetsRuntime(
                          section,
                          group,
                          rowIndex,
                          row,
                          scheduleFields
                        )}
                      {plainFields.map((field) => {
                        if (isLegalHeirsMappedField(field)) {
                          return this.renderLegalHeirsFieldTile(
                            section,
                            group,
                            rowIndex,
                            row,
                            field
                          );
                        }
                  const foHint = this.frontOfficeHintForField(field);
                  const tagHint = labelTagHintForField(field);
                  const verifyKey = repeatableRowVerifyKey(section.id, group.id, rowIndex, field.id);
                  const cellInput = (
                    <>
                      {this.renderFieldInput(
                        field,
                        row[field.id] ?? "",
                        (val) =>
                          this.setRepeatableCell(section.id, group.id, rowIndex, field.id, val),
                        `${section.id}-${group.id}-${rowIndex}-${field.id}`
                      )}
                      {this.renderConditionalFollowUps(field, {
                        parentValue: row[field.id] ?? "",
                        checklist: this.state.checklistValues,
                        storageKey: (vk) =>
                          repeatableRowFollowUpStorageKey(section.id, group.id, rowIndex, vk),
                        onFollowUpChange: (key, val) => this.setChecklistValue(key, val),
                        keyPrefix: `${section.id}-${group.id}-${rowIndex}-${field.id}`,
                      })}
                    </>
                  );
                  return (
                    <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-2">
                      <div
                        className={`dvc-field-tile dvc-form-control py-2${
                          field.disabled ? " dvc-field-disabled" : ""
                        }`}
                      >
                        <Form.Group className="mb-0">
                          <Form.Label className="small mb-1 font-weight-bold d-block">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                            {tagHint && (
                              <span className="dvc-fo-hint" title={tagHint.title}>
                                {tagHint.text}
                              </span>
                            )}
                            {foHint && (
                              <span className="dvc-fo-hint" title={foHint.title}>
                                {foHint.text}
                              </span>
                            )}
                          </Form.Label>
                          {this.renderFieldWithVerify(field, cellInput, verifyKey)}
                        </Form.Group>
                      </div>
                    </Col>
                  );
                      })}
                    </>
                  );
                })()}
              </Row>
            )}
          </>
        )}
      </div>
    );
  }

  renderDeedDocumentsInSaveOrder(section: ChecklistSectionDef) {
    const entries = collectDeedDocumentEntriesInSaveOrder(
      section,
      this.state.repeatableValues,
      this.scrutinyApiCache,
      this.deedMasterListCache
    );
    return entries
      .filter((entry) => deedDocumentEntryVisible(entry, this.state.checklistValues))
      .map((entry) => this.renderDeedDocumentEntryRuntime(section, entry));
  }

  renderMissingLodRuntime(section: ChecklistSectionDef, fields: ChecklistFieldDef[]) {
    return this.renderAutoRepeatableRuntime(
      section,
      fields,
      MISSING_LOD_REPEATABLE_SUFFIX,
      "Entry"
    );
  }

  renderSectionRuntimeFields(section: ChecklistSectionDef) {
    const flow = sectionFlowMode(section);
    const gates = sortDeedGatesBySaveOrder(
      sectionGateFields(section),
      section,
      this.state.repeatableValues,
      this.scrutinyApiCache,
      this.deedMasterListCache
    );
    const groupFieldIds = fieldIdsInDeedGroups(section);
    const gateIds = new Set(gates.map((g) => g.id));
    const standaloneFields = section.fields.filter(
      (f) => !gateIds.has(f.id) && !groupFieldIds.has(f.id)
    );
    const missingLodFields = this.missingLodMappedFields(section);
    const preDisbursementFields = mappedFieldsForTagSet(section, PRE_DISBURSEMENT_DYNAMIC_TAG_IDS);
    const postDisbursementFields = mappedFieldsForTagSet(section, POST_DISBURSEMENT_DYNAMIC_TAG_IDS);
    const missingLodIds = new Set(missingLodFields.map((f) => f.id));
    const preDisbursementIds = new Set(preDisbursementFields.map((f) => f.id));
    const postDisbursementIds = new Set(postDisbursementFields.map((f) => f.id));
    const hasMissingLodRows =
      (this.state.repeatableValues[repeatableEntriesKey(section.id, MISSING_LOD_REPEATABLE_SUFFIX)]
        ?.length || 0) > 0;
    const hasPreDisbursementRows =
      (this.state.repeatableValues[repeatableEntriesKey(section.id, PRE_DISBURSEMENT_REPEATABLE_SUFFIX)]
        ?.length || 0) > 0;
    const hasPostDisbursementRows =
      (this.state.repeatableValues[repeatableEntriesKey(section.id, POST_DISBURSEMENT_REPEATABLE_SUFFIX)]
        ?.length || 0) > 0;
    const renderWholeSectionAsMissingLodRows = missingLodFields.length > 0 && hasMissingLodRows;
    const standaloneNonMissingLod = renderWholeSectionAsMissingLodRows
      ? []
      : standaloneFields.filter((f) => {
          if (missingLodIds.has(f.id) && hasMissingLodRows) return false;
          if (preDisbursementIds.has(f.id) && hasPreDisbursementRows) return false;
          if (postDisbursementIds.has(f.id) && hasPostDisbursementRows) return false;
          return true;
        });
    const plainGroups = (section.repeatableGroups || []).filter(
      (g) => !g.deedMasterId && !g.ecHierarchyLevel && !g.surveyHierarchyLevel && !g.naturePropertyKey
    );

    if (flow === "bank_product") {
      const fileBankProductId = resolveFileBankProductId(this.state.frontOfficePrefill);
      const visibleBankGroups = bankGroupsVisibleForFile(section, fileBankProductId);
      if (!visibleBankGroups.length) return null;
      return (
        <>
          {visibleBankGroups.map((group) => (
            <div key={group.id} className="dvc-bank-product-card mb-4 p-3 border rounded bg-white">
              <div className="dvc-deed-type-head mb-3">
                <span className="dvc-deed-type-title">{group.label}</span>
              </div>
              {group.fields.length > 0 ? (
                <Row>
                  {group.fields.map((field) => {
                    const foHint = this.frontOfficeHintForField(field);
                    const tagHint = labelTagHintForField(field);
                    const fieldInput = (
                      <>
                        {this.renderFieldInput(field)}
                        {this.renderConditionalFollowUps(field)}
                      </>
                    );
                    return (
                      <Col md={layoutToColMd(field.layout)} key={field.id} className="mb-3">
                        <div
                          className={`dvc-field-tile dvc-form-control${
                            field.disabled ? " dvc-field-disabled" : ""
                          }`}
                        >
                          <Form.Group className="mb-0">
                            <Form.Label className="small mb-2 font-weight-bold d-block">
                              {field.label}
                              {field.required && <span className="text-danger"> *</span>}
                              {tagHint && (
                                <span className="dvc-fo-hint" title={tagHint.title}>
                                  {tagHint.text}
                                </span>
                              )}
                              {foHint && (
                                <span className="dvc-fo-hint" title={foHint.title}>
                                  {foHint.text}
                                </span>
                              )}
                            </Form.Label>
                            {this.renderFieldWithVerify(field, fieldInput, field.id)}
                          </Form.Group>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                <p className="small text-muted mb-0">No checklist fields configured.</p>
              )}
            </div>
          ))}
        </>
      );
    }

    if (flow === "survey_verification") {
      return this.renderSurveyVerificationRuntime(section);
    }

    if (flow === "ec_verification") {
      return this.renderEcVerificationRuntime(section);
    }

    const hasStandalones = standaloneNonMissingLod.length > 0;
    const hasPlainGroups = plainGroups.length > 0;
    const hasGates = gates.length > 0;
    return (
      <>
        {hasStandalones &&
          standaloneNonMissingLod.map((field) => this.renderRuntimeGeneralFieldRow(field))}
        {hasMissingLodRows &&
          this.renderMissingLodRuntime(
            section,
            renderWholeSectionAsMissingLodRows ? standaloneFields : missingLodFields
          )}
        {hasPreDisbursementRows &&
          this.renderAutoRepeatableRuntime(
            section,
            preDisbursementFields,
            PRE_DISBURSEMENT_REPEATABLE_SUFFIX,
            "Pre Disbursement"
          )}
        {hasPostDisbursementRows &&
          this.renderAutoRepeatableRuntime(
            section,
            postDisbursementFields,
            POST_DISBURSEMENT_REPEATABLE_SUFFIX,
            "Post Disbursement"
          )}
        {hasPlainGroups &&
          plainGroups.map((g) => this.renderRepeatableGroupRuntime(section, g, true))}
        {hasGates && this.renderDeedDocumentsInSaveOrder(section)}
      </>
    );
  }

  render() {
    const { master, masterLoading, loadError, validationMessages } = this.state;
    return (
      <>
        <style type="text/css">{DVC_CSS}</style>
        <div
          className="dvc-root"
          style={{
            background:
              "linear-gradient(180deg, #f0f9ff 0%, #f8fafc 18%, #fafbfc 50%, #ffffff 100%)",
            padding: "12px",
            borderRadius: 12,
          }}
        >
          {this.props.title !== "" && (
            <div className="dvc-hero mb-3">
              <div className="dvc-hero-inner">
                <h6 className="mb-1 font-weight-bold">
                  {this.props.title ?? "Dynamic checklist"}
                </h6>
                {this.props.intro && (
                  <p
                    className="mb-0 small dvc-hero-lead"
                    style={{ maxWidth: "52rem", lineHeight: 1.55 }}
                  >
                    {this.props.intro}
                  </p>
                )}
              </div>
            </div>
          )}
          {loadError && (
            <Alert variant="danger" className="mb-3 small">
              {loadError}
            </Alert>
          )}
          {validationMessages.length > 0 && (
            <Alert variant="danger" className="shadow-sm">
              <div className="font-weight-bold mb-1">Required fields missing</div>
              <ul className="mb-0 pl-3">
                {validationMessages.map((m) => (
                  <li key={m}>{m}</li>
                ))}
              </ul>
            </Alert>
          )}
          {masterLoading ? (
            <Alert variant="light" className="text-muted small border">
              Loading dynamic checklist…
            </Alert>
          ) : master.length === 0 ? (
            <Alert variant="warning" className="small">
              No dynamic checklist master has been configured yet. Visit the
              "Dynamic Checklist Management" page to set it up.
            </Alert>
          ) : (
            master.map((section) => {
              const open = this.state.sectionUiOpen[section.id] === true;
              const warn = section.headerVariant === "warning";
              const flow = sectionFlowMode(section);
              const fileBankProductId = resolveFileBankProductId(
                this.state.frontOfficePrefill
              );
              const surveyNatureKeys = resolveSurveyNaturePropertyKeys(
                this.state.frontOfficePrefill,
                this.state.propertyDetailsPrefill,
                this.state.generalDetailsByDocument,
                null
              );
              const rgFieldCount = (section.repeatableGroups || []).reduce(
                (n, g) => n + g.fields.length,
                0
              );
              const hierarchyFieldCount = surveyHierarchyLinkedGroups(section).reduce(
                (n, g) => n + g.fields.length,
                0
              );
              const totalFields =
                flow === "bank_product"
                  ? bankProductSectionFieldCount(section, fileBankProductId)
                  : flow === "survey_verification"
                    ? surveyNatureSectionFieldCountForVisibleGroups(section, surveyNatureKeys) +
                      hierarchyFieldCount
                    : flow === "ec_verification"
                      ? ecSectionFieldCount(section)
                      : section.fields.length + rgFieldCount;
              if (
                flow === "bank_product" &&
                !bankGroupsVisibleForFile(section, fileBankProductId).length
              ) {
                return null;
              }
              if (flow === "survey_verification") {
                const hasConfiguredNature =
                  surveyConfiguredNatureGroups(section).length > 0 ||
                  surveyConfiguredNatureCards(section).length > 0;
                const hasHierarchy = hierarchyFieldCount > 0;
                if (!hasConfiguredNature && !hasHierarchy) {
                  return null;
                }
              }
              if (flow === "ec_verification") {
                if (ecSectionFieldCount(section) <= 0) return null;
              }
              return (
                <Card key={section.id} className="mb-3 dvc-card dvc-runtime-section">
                  <Card.Header
                    className={`pt-3 px-3 pb-2 d-flex align-items-center justify-content-between dvc-section-accordion-head ${
                      warn ? "dvc-runtime-warn-head" : ""
                    }`}
                    role="button"
                    tabIndex={0}
                    aria-expanded={open}
                    onClick={() => this.toggleSectionOpen(section.id)}
                    onKeyDown={(e) => this.onSectionHeaderKeyDown(section.id, e)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center justify-content-between flex-wrap w-100 pr-1">
                      <h6 className="mb-0">{section.title}</h6>
                      <div className="d-flex align-items-center">
                        <Badge
                          pill
                          variant="light"
                          className="text-muted border font-weight-normal mr-2"
                        >
                          {totalFields} field{totalFields === 1 ? "" : "s"}
                        </Badge>
                        <span
                          className={`dvc-section-accordion-btn${open ? " is-open" : ""}`}
                          aria-hidden
                        >
                          <i className="fa fa-chevron-down" />
                        </span>
                      </div>
                    </div>
                  </Card.Header>
                  <Collapse in={open}>
                    <div>
                      <Card.Body className="pt-3 border-top-0">
                        {this.renderSectionRuntimeFields(section)}
                      </Card.Body>
                    </div>
                  </Collapse>
                </Card>
              );
            })
          )}
        </div>
      </>
    );
  }
}

export default DynamicChecklistRuntime;
